import React, {useEffect, useMemo, useRef, useState} from "react";
import {useReactToPrint} from "react-to-print";
import SaveAsTemplate from "../../common/SaveAsTemplate";
import "./index.css";
import {useDispatch, useSelector} from "react-redux";
import {
    fetchTemplates,
    postAdvancedType,
    postAdvancedTypeBuys,
    postAdvancedTypeSales,
    postBankAccounts,
    postBasicType,
    postBuys,
    postBuysGeneralSettings,
    postCashRegisters,
    postClient,
    postClientMovements,
    postClientPayment,
    postClientsSettings,
    postPOS,
    postPriceList,
    postProduct,
    postProductMovements,
    postSales,
    postQuotations,
    sendMail,
    postSalesGeneralSettings,
    postSupplier,
    postSupplierMovements,
    postSupplierPayment,
    postSuppliersSettings,
    putAdvancedType,
    putAdvancedTypeBuys,
    putAdvancedTypeSales,
    putBankAccounts,
    putBasicType,
    putBuys,
    putBuysGeneralSettings,
    putCashRegisters,
    putClient,
    putClientMovements,
    putClientPayment,
    putCompanyEmailSmtp,
    putPOS,
    putPriceList,
    putPrimerMyDataData,
    putProduct,
    putProductMovements,
    putSales,
    putSalesGeneralSettings,
    putQuotations,
    putTemplate,
    cancelMyDataSale,
    putSupplier,
    putSupplierMovements,
    putSupplierPayment,
    postEmployee,
    putEmployee,
    postAccountingAccount,
    putAccountingAccount,
    postAccountingRecord,
    putAccountingRecord,
    cancelMyDataBuy,
    cancelMyDataAccountingRecord,
    postCashSettings,
    postWorkMovement,
    postWorkPermit,
    putWorkPermit,
    fetchAdvancedTypesSales, postAccountingClosure, postNewVisit, postActiveVisit, postFixedAssetsSettings,
    postFixedAsset, updateFixedAsset, postFixedAssetMovement, updateFixedAssetMovement, postFixedAssetRecord,
    updateFixedAssetRecord, cancelMyDataFixedAssetRecord, postCheque, updateCheque, postLoan, updateLoan, postCard,
    updateCard,
} from "../../../_apis/api";
import AdvancedCombobox from "../AdvancedCombobox";
import {
    checkPermission,
    clientPaymentsPrintTemplates,
    getClientPaymentPrintData,
    getCurrentUser,
    getDefaultOptionByValue,
    getGeneratedMaskCode,
    getGeneratedMaskCodeCLient,
    getMaskCodeWithNewPrefix,
    getMultiSelectOptionsToArray,
    getSalesPrintData,
    getTemplateOptions,
    isValidBuysData,
    isValidSalesData,
    isValidQuotationsData,
    leadingZeros,
    salesPrintTemplates,
    getBuysPrintData,
    buysPrintTemplates, isEmpty, generateMyDataUID, validateEmail, getDocumentLabel,
    getQuotationsPrintData,
    quotationsPrintTemplates,
    getOptionsByData, quickClone,
} from "../../../_helpers/commonFunctions";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {
    setNewPriceList,
    setNewProductMovements,
    setSelectedProduct,
    setSelectedProductMovementsTemplate,
    setSelectedProductPriceListTemplate,
    setSelectedProductTemplate,
} from "../../../_reducers/DataPanel/Products/productsSlice";
import {
    findObjectFromArrayOfObjects, getObjectFromArrayOfObjects,
} from "../../../_helpers/helperFunctions";
import {
    setSaveBuys,
    setSaveBuysSettings,
    setSaveClientPayments,
    setSaveEditClientInWholeSystem,
    setSaveEditBankAccounts,
    setSaveEditCashRegister,
    setSaveEditClientPayments,
    setSaveEditPOS,
    setSaveEditSupplierPayments,
    setSaveNewBankAccounts,
    setSaveNewCashRegister,
    setSaveNewPOS,
    setSaveNewPriceList,
    setSaveNewProduct,
    setSaveNewProductMovements,
    setSaveSales,
    setSaveSalesSettings,
    setSendEmail,
    setSaveSupplierPayments,
    setSaveEditProduct,
    setSaveEditBuys,
    setSaveCashAccountingSettings,
    setSendEmployeeQROnSave,
    setSaveNewWorkPermit,
    setSendEmployeeNewPasswordOnSave,
    setSaveEditEmployee,
    setSaveNewEmployee,
    setRememberInnerTab,
    setUpdateInnerTab,
    setSaveEditWorkPermit,
    setSendEmployeeChangesToErgani,
    setSaveNewAccountingClosure,
    setSaveNewVisit,
    setSaveActiveVisit, setSaveEditClient, setSaveFixedAssetsSettings, setSaveNewFixedAssetMovement,
    setSaveEditFixedAssetMovement, setSaveNewFixedAssetRecord, setSaveEditFixedAssetRecord,
    setSaveQuotations,
    setSaveEditQuotations, setSavePrimerAiUrl, setSaveNewCheque,
} from "../../../_reducers/activitySlice";
import {
    setEditClient,
    setEditClientMovements,
    setNewClient,
    setNewClientMovements,
    setNewClientPayment,
    setSelectedClientMovementsTemplate,
    setSelectedClientTemplate,
} from "../../../_reducers/DataPanel/Clients/clientSlice";
import {toast} from "react-toastify";
import {
    setNewBankAccount, setNewCashRegisters,
} from "../../../_reducers/DataPanel/Cash/cashSlice";
import Checkbox from "../../common/CheckBox";
import Dropdown from "../Dropdown";
import {
    resetNewSales,
    setNewSales,
    setNewQuotations,
    setEditQuotations,
    setNewPrimerAiUrl,
    setPrintLayout,
    setSelectedSalesTemplate,
    setCorrelatedSaleData,
    setSelectedQuotationsTemplates, setSelectedPrimerAiUrlTemplates
} from "../../../_reducers/DataPanel/Sales/salesSlice";
import axios from "axios";
import SalesPrintTemplateEnglish1 from "../../layouts/PrintLayout/sales-print-template1-english";
import SalesPrintTemplateGreek1 from "../../layouts/PrintLayout/sales-print-template1-greek";
import {
    setEditSupplier,
    setEditSupplierMovements,
    setNewSupplier,
    setNewSupplierMovements, setNewSupplierPayment,
    setSelectedSupplierMovementsTemplate,
    setSelectedSupplierTemplate
} from "../../../_reducers/DataPanel/Suppliers/supplierSlice";
import {setNewBuys} from "../../../_reducers/DataPanel/Buys/buysSlice";
import Input from "../../common/Input";
import Start from "../../layouts/data-panel/start";
import {removeTab, tabInActivity} from "../../../_reducers/TabsSlice";
import ClientPaymentPrintTemplate1Greek from "../../layouts/PrintLayout/client-payment-print-template1-greek";
import SalesPrintA5Greek from "../../layouts/PrintLayout/sales-print-a5-greek";
import SalesPrintA5English from "../../layouts/PrintLayout/sales-print-a5-english";
import SalesPrintA5DoubleGreek from "../../layouts/PrintLayout/sales-print-a5-double-greek";
import SalesPrintA5DoubleEnglish from "../../layouts/PrintLayout/sales-print-a5-double-english";
import BuyPrintA4Greek from "../../layouts/PrintLayout/buy-print-a4-greek";
import BuyPrintA4English from "../../layouts/PrintLayout/buy-print-a4-english";
import ClientpaymentPrintTemplate1English from "../../layouts/PrintLayout/client-payment-print-template1-english";
import moment from "moment";
import DeleteModal from "../POPUP-COMPONENTS/Delete-Modal/deleteModal";
import {addToForceRefresh} from "../../../_reducers/SearchTableSlice";
import BetterCheckBox from "../../common/BetterCheckBox";
import {isDeliveryNoteTypes} from "../../../_data/mydata/isDeliveryNoteTypes";
import {setNewAccountingClosure} from "../../../_reducers/DataPanel/Accounting/accountingSlice";
import {resetActiveVisit, resetNewVisit} from "../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import ThermalPrint55 from "../../layouts/PrintLayout/thermal-print-55mm";
import ThermalPrint80 from "../../layouts/PrintLayout/thermal-print-80mm";
import ThermalPrint110 from "../../layouts/PrintLayout/thermal-print-110mm";
import RefreshEditModal from "../POPUP-COMPONENTS/Refresh-Edit-Modal/RefreshEditModal";
import {
    setForceRefreshDclActive, setRefreshEditDcl, setRefreshSelectedDcl,
    setShowDclAfterSaleNew,
    setShowDclPageAfterSaleNew
} from "../../../_reducers/DataPanel/Dcl/dclSlice";
import VisitExecutedReferrals
    from "../../layouts/data-panel/Prescriptions/OuterComponents/VisitExecutedReferrals";
import {
    validateAccountingRecord,
    validateBuyObject,
    validateClientPayment,
    validateFixedAsset,
    validateFixedAssetMovement,
    validateFixedAssetRecord,
    validateSaleObject,
    validateQuotationObject,
    validateSupplierPayment,
    validatePrimerAiUrlObject,
    validateNewClientObject,
    validateEditClientObject,
    validateClientMovementObject,
    validateSupplierObject,
    validateEditSupplierObject,
    validateSupplierMovementObject,
    validateProductObject,
    validateEditProductObject,
    validateProductMovementObject,
    validatePriceListObject,
    validateAdvancedTypeObject,
    validateCashRegisterObject,
    validateBankAccountObject,
    validatePOSObject,
    validateSalesSettingsObject,
    validateBuysSettingsObject,
    validateEditSaleObject,
    validateEditQuotationObject,
    validateEmployeeObject,
    validateEditEmployeeObject,
    validateAccountingAccountObject,
    validateEditAccountingAccountObject,
    validateAccountingClosureObject,
    validateWorkPermitObject,
    validateEditWorkPermitObject,
    validateVisitObject, validateCheque, validateLoan, validateCard,
} from "../../../_helpers/validator";
import useMediaQuery from "../../../hooks/useMediaQuery";
import {openNewSale, openNewVisit, openTabByType} from "../../../_helpers/tabOpeners";
import {useTranslation} from "../../../hooks/useTranslation";

const apiURL2 = process.env.REACT_APP_API_URL2;

const DataPanel = ({
       templateEnable,
       templateType,
       tabs,
       deleteBtn,
       saveBtn,
       clearBtn,
       saveandrepeat,
       headerNew,
       printLayoutDropdown,
       printBtn,
       sendEmailOnSave,
       convertDocument,
       convertQuotation,
       issueCreditDocument,
       cancelMyDataInvoice,
       mainTabName, // It is not mainTabName anymore, it is the new tab object { tabType, key }
   }) => {
    const tabKey = mainTabName.key;
    const onSuccess = () => dispatch(tabInActivity({ key: tabKey }));
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    // Data
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const SUPPLIERS_DATA = useSelector((state) => state.SUPPLIERS_DATA);
    const CASH_DATA = useSelector((state) => state.CASH_DATA);
    const SALES = useSelector((state) => state.SALES);
    const DCL = useSelector((state) => state.DCL);
    const BUYS = useSelector((state) => state.BUYS);
    const COMPANY_DATA = useSelector((state) => state.COMPANY_DATA);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const BUYS_SETTINGS = useSelector((state) => state.BUYS_SETTINGS);
    const ACCOUNTING_DATA = useSelector((state) => state.ACCOUNTING_DATA);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const PAYROLL = useSelector((state) => state.PAYROLL);
    const PRESCRIPTION = useSelector((state) => state.PRESCRIPTION);
    const FIXED_ASSETS = useSelector((state) => state.FIXED_ASSETS);

    const productCategories = useSelector((state) => state.PRODUCTS_CATEGORY.categories);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const [activeLink, setActiveLink] = useState(!isEmpty(ACTIVITY.rememberInnerTab[tabKey]) ? ACTIVITY.rememberInnerTab[tabKey] : 1);
    const containerRefs = useRef({});

    const [showTemplateConfirmation, setShowTemplateConfirmation] = useState(false);
    const [defaultTemplate, setDefaultTemplate] = useState(null);
    const [selectedTemplate, setSelectedTemplate] = useState();
    const [loadingSave, setLoadingSave] = useState(false);
    const [activePriceListModal, setActivePriceListModal] = useState(false);
    const [loadingSaveAndRepeat, setLoadingSaveAndRepeat] = useState(false);
    const [loadingSaveActiveVisitInvoice, setLoadingSaveActiveVisitInvoice] = useState(false);
    const [recipientEmails, setRecipientEmails] = useState([]);
    const [selectedRecipientEmails, setSelectedRecipientEmails] = useState([]);
    const [emailError, setEmailError] = useState(false);
    const [selectedCustomRecipientEmails, setSelectedCustomRecipientEmails] = useState([]);
    const [showConvertDocumentConfirmation, setShowConvertDocumentConfirmation] = useState(false);
    const [showConvertQuotationConfirmation, setShowConvertQuotationConfirmation] = useState(false);
    const [showIssueCreditDocumentConfirmation, setShowIssueCreditDocumentConfirmation,] = useState(false);
    const [showCancelDocumentConfirmation, setShowCancelDocumentConfirmation] = useState(false);
    const [showVisitExecutedReferrals, setShowVisitExecutedRefferals] = useState(false);
    const scrollToEnd = useRef(null);

    // These settings work from the view-sales.jsx file as per the selected conversion and credit document
    const [enableConvertDocumentButton, setEnableCDBtn] = useState(false);
    const [enableIssueCreditDocumentButton, setEnableIssueCDBtn] = useState(false);

    const [enableConvertQuotationButton, setEnableConvertQuotationButton] = useState(false);
    const [convertQuotationToType, setConvertQuotationToType] = useState(null);

    // Disable button to reduce the changes of double click.
    const [disableConvertOkBtn, setDisableConvertOkBtn] = useState(false);
    const [disableIssueCreditOkBtn, setDisableIssueCreditOkBtn] = useState(false);
    const [disableCancelDocumentOkBtn, setDisableCancelDocumentOkBtn] = useState(false);

    // Same is used Settings Document Type file for advanced document types.
    let printLayoutOptions = salesPrintTemplates();

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [toBeDeleted, setToBeDeleted] = useState("");
    const [deleteModalTableName, setDeleteModalTableName] = useState("");
    const documentTypesOptions = useMemo(() => getOptionsByData(SETTINGS.settings.advancedTypesSales, "_id", "name"), [SETTINGS.settings.advancedTypesSales]);

    const [showPOSModal, setShowPOSModal] = useState(false);
    const [showPOSModalText, setShowPOSModalText] = useState("");
    const [showPOSModalCancel, setShowPOSModalCancel] = useState(false);
    const [paymentReturnable, setPaymentReturnable] = useState(false);
    const [showPaymentReturnModal, setShowPaymentReturnModal] = useState(false);

    const [emronAdminCancellationModal, setEmronAdminCancellationModal] = useState(false);

    const isEmronConnectFileERP = useSelector((state) => state.ACTIVITY.isEmronConnectFileERP);

    const [showCancelVisitModal, setShowCancelVisitModal] = useState(false);
    const [loadingCancelActiveVisit, setLoadingCancelActiveVisit] = useState(false);

    const isMobileScreen = useMediaQuery("(max-width: 980px)");
    const slideBarToggle = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarToggle);

    useEffect(() => {
        if (ACTIVITY.updateInnerTab >= 0) {
            setActiveLink(ACTIVITY.updateInnerTab);
            dispatch(setRememberInnerTab({[tabKey] : ACTIVITY.updateInnerTab}));
            dispatch(setUpdateInnerTab(-1));
        }
    }, [ACTIVITY.updateInnerTab])

    useEffect(() => {
        getPaymentReturnable();
        if (templateEnable) dispatch(fetchTemplates(requestData));
    }, []);

    const getPaymentReturnable = () => {
        if (templateType === "editClientPayments" && CLIENTS_DATA.editClientPayment._id) {
            axios.post(process.env.REACT_APP_API_URL2 + "/client/is-client-payment-returnable", { company: company.id, cpId: CLIENTS_DATA.editClientPayment._id}, {
                headers: {"Content-Type": "application/json"},
            }).then((res) => {
                if (res.data.status === "200") {
                    if (!isEmpty(res.data.returnable)) {
                        setPaymentReturnable(res.data.returnable);
                    } else {
                        setPaymentReturnable(false);
                    }
                }
            }).catch((err) => {
                console.log(err);
            })
        }
    }

    const requestData = {
        type: templateType, isActive: "active", company: company.id, year: company.year.toString(),
    }

    // This will handle the different options
    const templateOptions = (type) => {
        switch (type) {
            case "product":
                return getTemplateOptions(PRODUCTS_DATA.productTemplates);
            case "editProduct":
                return getTemplateOptions(PRODUCTS_DATA.productTemplates);
            case "productMovements":
                return getTemplateOptions(PRODUCTS_DATA.productMovementsTemplates);
            case "editProductMovements":
                return getTemplateOptions(PRODUCTS_DATA.productMovementsTemplates);
            case "priceList":
                return getTemplateOptions(PRODUCTS_DATA.productPriceListTemplates);
            case "editPriceList":
                return getTemplateOptions(PRODUCTS_DATA.productPriceListTemplates);
            case "client":
                return getTemplateOptions(CLIENTS_DATA.clientTemplates);
            case "clientMovements":
                return getTemplateOptions(CLIENTS_DATA.clientMovementsTemplates);
            case "supplier":
                return getTemplateOptions(SUPPLIERS_DATA.supplierTemplates);
            case "supplierMovements":
                return getTemplateOptions(SUPPLIERS_DATA.supplierMovementsTemplates);
            case "sales":
                return getTemplateOptions(SALES.salesTemplates);
            case "quotations":
                return getTemplateOptions(SALES.quotationsTemplates);
            case "editQuotations":
                return getTemplateOptions(SALES.quotationsTemplates);
            case "primerAiUrl":
                return getTemplateOptions(SALES.primerAiUrlTemplates);
            case "buys":
                return getTemplateOptions(BUYS.buysTemplates);
            case "clientPayments":
                return getTemplateOptions(CLIENTS_DATA.clientPaymentsTemplates);
            case "supplierPayments":
                return getTemplateOptions(SUPPLIERS_DATA.supplierPaymentsTemplates);
            case "accountingClosure":
                return getTemplateOptions(ACCOUNTING_DATA.accountingClosureTemplates);
            default:
                return [];
        }
    }

    // This will handle the different options
    const getSalesPrintTemplateData = (type) => {
        switch (type) {
            case "sales":
                return getSalesPrintData(type, SALES.newSales, COMPANY_DATA, SETTINGS, SALES.printLayout);
            case "editSales":
                return getSalesPrintData(type, SALES.editSales[tabKey], COMPANY_DATA, SETTINGS, SALES.printLayout);
            case "quotations":
                return getQuotationsPrintData(type, SALES.newQuotations, COMPANY_DATA, SETTINGS, SALES.printLayout);
            case "editQuotations":
                if (!SALES.editQuotations[tabKey]) return {};
                return getQuotationsPrintData(type, SALES.editQuotations[tabKey], COMPANY_DATA, null, SALES.printLayout);
            case "clientPayments":
                return getClientPaymentPrintData(COMPANY_DATA, CLIENTS_DATA.newClientPayment);
            case "editClientPayments":
                return getClientPaymentPrintData(COMPANY_DATA, CLIENTS_DATA.editClientPayment);
            case "buys":
                return getBuysPrintData(type, BUYS, COMPANY_DATA, null, SALES.printLayout);
            case "editBuys":
                return getBuysPrintData(type, BUYS, COMPANY_DATA, null, SALES.printLayout);
            default:
                return [];
        }
    }

    const printTemplateData = useMemo(() => getSalesPrintTemplateData(templateType));
    // This will handle the form data for save as template
    const templateFormData = (type) => {
        switch (type) {
            case "product":
                return PRODUCTS_DATA.selectedProduct;
            case "editProduct":
                return PRODUCTS_DATA.selectedEditProduct[tabKey];
            case "productMovements":
                return PRODUCTS_DATA.newProductMovements;
            case "editProductMovements":
                return PRODUCTS_DATA.editProductMovements;
            case "priceList":
                return PRODUCTS_DATA.newPriceList;
            case "editPriceList":
                return PRODUCTS_DATA.editPriceList;
            case "client":
                return CLIENTS_DATA.newClient;
            case "clientMovements":
                return CLIENTS_DATA.newClientMovements;
            case "supplier":
                return SUPPLIERS_DATA.newSupplier;
            case "supplierMovements":
                return SUPPLIERS_DATA.newSupplierMovements;
            case "sales":
                return SALES.newSales;
            case "quotations":
                return SALES.newQuotations;
            case "editQuotations":
                return SALES.editQuotations;
            case "primerAiUrl":
                return SALES.newPrimerAiUrl;
            case "buys":
                return BUYS.newBuys;
            case "clientPayments":
                return CLIENTS_DATA.newClientPayment;
            case "supplierPayments":
                return SUPPLIERS_DATA.newSupplierPayment
            case "accountingClosure":
                return ACCOUNTING_DATA.newAccountingClosure;
            default:
                return [];
        }
    }

    useEffect(() => {
        if (SALES.newSales.documentType) {
            const dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, SALES.newSales.documentType, '_id');
            if (dtData.length > 0) {
                const selectedDocumentTypeData = dtData[0];
                if (selectedDocumentTypeData?.printTemplate) {
                    dispatch(setPrintLayout(selectedDocumentTypeData?.printTemplate));
                }
            }
        }
    }, [SALES.newSales.documentType])

    useEffect(() => {
        if (SALES.newQuotations.documentType) {
            const dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, SALES.newQuotations.documentType, '_id');
            if (dtData.length > 0) {
                const selectedDocumentTypeData = dtData[0];
                if (selectedDocumentTypeData?.printTemplate) {
                    dispatch(setPrintLayout(selectedDocumentTypeData?.printTemplate));
                }
            }
        }
    }, []);

    useEffect(() => {
        if (CLIENTS_DATA.newClientPayment.documentType) {
            const dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypes, CLIENTS_DATA.newClientPayment.documentType, '_id');
            if (dtData.length > 0) {
                const selectedDocumentTypeData = dtData[0];
                if (selectedDocumentTypeData?.printTemplate) {
                    dispatch(setPrintLayout(selectedDocumentTypeData?.printTemplate));
                }
            }
        }
    }, [CLIENTS_DATA.newClientPayment.documentType])

    useEffect(() => {
        let selectedDocumentTypeData;
        const editSale = SALES.editSales[tabKey];
        if (editSale?.documentType && editSale?.fromMyDataReport !== "true") {
            let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, editSale.documentType, '_id');
            if (dtData.length > 0) {
                selectedDocumentTypeData = dtData['0'];
            }
            if (selectedDocumentTypeData?.conversionDocument) {
                setEnableCDBtn(true);
            }
            if (selectedDocumentTypeData?.creditDocument && selectedDocumentTypeData?.myDataType !== "8.2") {
                setEnableIssueCDBtn(true);
            }

            if (editSale?._id && templateType === "editSales" && editSale?.documentCategory !== "Convert Document" && editSale?.documentCategory !== "Credit Document") {
                axios
                    .get(process.env.REACT_APP_API_URL2 + `/sale/credit-document-list/${editSale?._id}`)
                    .then((res) => {
                        if (res.data && res.data.status === "200") {
                            if (res.data.data.length > 0) {
                                setEnableIssueCDBtn(false);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                axios
                    .get(process.env.REACT_APP_API_URL2 + `/sale/list-convert-document/${editSale._id}`)
                    .then((res) => {
                        if (res.data && res.data.status === "200") {
                            if (res.data.data.length > 0) {
                                setEnableCDBtn(false);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            // Hide the covert and issues credit document button from their pages.
            if (templateType === "editSales" && (editSale?.documentCategory === "Convert Document" || editSale?.documentCategory === "Credit Document")) {
                setEnableCDBtn(false);
                setEnableIssueCDBtn(false);
            }
        }
    }, [SALES.editSales[tabKey], SETTINGS.settings.advancedTypesSales])

    useEffect(() => {
        const editQuotation = SALES.editQuotations[tabKey];
        if (editQuotation?.documentType) {
            setEnableConvertQuotationButton(true);
        }
    }, [SALES.editQuotations[tabKey]?.documentType]);

    const handleTemplateChange = (e) => {
        e = e.row; // advanced combobox data
        setSelectedTemplate(e); // This will set the template details temporarily.
        if (ACTIVITY.editing || ACTIVITY.saveNewProduct || ACTIVITY.saveSales || ACTIVITY.saveQuotations || ACTIVITY.saveClientPayments
            || ACTIVITY.saveNewProductMovements || ACTIVITY.saveNewPriceList || ACTIVITY.saveNewAccountingClosure) {
            // Ask for confirmation if editing true
            setShowTemplateConfirmation(true);
        } else {
            // Set Selected Template to redux
            setTemplateToRedux(templateType, e);

            // Change selected template option
            setDefaultTemplate(e);

            // Set Editing True
            if (templateType === "product") {
                dispatch(setSaveNewProduct(true));
            } else if (templateType === "productMovements") {
                dispatch(setSaveNewProductMovements(true));
            } else if (templateType === "priceList") {
                dispatch(setSaveNewPriceList(true));
            } else if (templateType === "sales") {
                dispatch(setSaveSales(true));
            } else if (templateType === "quotations") {
                dispatch(setSaveQuotations(true));
            } else if (templateType === "editQuotations") {
                dispatch(setSaveEditQuotations(true));
            } else if (templateType === "primerAiUrl") {
                dispatch(setSavePrimerAiUrl(true));
            } else if (templateType === "editSales") {
                dispatch(setSaveSales(true));
            } else if (templateType === "buys") {
                dispatch(setSaveBuys(true));
            } else if (templateType === "editBuys") {
                dispatch(setSaveEditBuys(true));
            } else if (templateType === "accountingClosure") {
                dispatch(setSaveNewAccountingClosure(true));
            }
        }
    }

    const handleConfirmTemplate = () => {
        // Change selected template option
        setDefaultTemplate(selectedTemplate);

        // Set Selected Template to redux
        setTemplateToRedux(templateType, selectedTemplate);

        // Hide Popup
        setShowTemplateConfirmation(false);
    }

    // It will set selected template data
    const setTemplateToRedux = (templateType, selectedTemplate) => {
        let selectedTemplateData = [];
        if (selectedTemplate && selectedTemplate.value) {
            switch (templateType) {
                case "product":
                    selectedTemplateData = getObjectFromArrayOfObjects(PRODUCTS_DATA.productTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        let productData = JSON.parse(selectedTemplateData["0"].templateData);
                        let tempProductCode = getGeneratedMaskCode('product', productData.category, productCategories)
                        productData.code = getMaskCodeWithNewPrefix(tempProductCode, productData.categoryMaskCodePrefix);
                        productData.installationsInventory = [];
                        dispatch(setSelectedProductTemplate(selectedTemplateData["0"])); // Set products selected template data
                        dispatch(setSelectedProduct(productData)); // set template data
                    }
                    break;
                case "productMovements":
                    selectedTemplateData = getObjectFromArrayOfObjects(PRODUCTS_DATA.productMovementsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedProductMovementsTemplate(selectedTemplateData["0"])); // Set products movement selected template data
                        dispatch(setNewProductMovements(JSON.parse(selectedTemplateData["0"].templateData))); // set template data
                    }
                    break;
                case "priceList":
                    selectedTemplateData = getObjectFromArrayOfObjects(PRODUCTS_DATA.productPriceListTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedProductPriceListTemplate(selectedTemplateData["0"])); // Set price data to selected template data
                        dispatch(setNewPriceList(JSON.parse(selectedTemplateData["0"].templateData))); // set template data
                    }
                    break;
                case "client":
                    selectedTemplateData = getObjectFromArrayOfObjects(CLIENTS_DATA.clientTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedClientTemplate(selectedTemplateData["0"])); // Set client selected template data
                        let clientData = JSON.parse(selectedTemplateData["0"].templateData);
                        const clientCategories = getObjectFromArrayOfObjects(CLIENTS_DATA.clientsSettings.categories, "active", "isActive");
                        const selectedCategory = findObjectFromArrayOfObjects(clientCategories, clientData.category, "_id");
                        if (selectedCategory) {
                            clientData.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
                            clientData.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, clientCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
                        }
                        dispatch(setNewClient(clientData)); // set new client data
                    }
                    break;
                case "supplier":
                    selectedTemplateData = getObjectFromArrayOfObjects(SUPPLIERS_DATA.supplierTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedSupplierTemplate(selectedTemplateData["0"])); // Set client selected template data
                        let supplierData = JSON.parse(selectedTemplateData["0"].templateData);
                        const supplierCategories = getObjectFromArrayOfObjects(SUPPLIERS_DATA.suppliersSettings.categories, "active", "isActive");
                        const selectedCategory = findObjectFromArrayOfObjects(supplierCategories, supplierData.category, "_id");
                        if (selectedCategory) {
                            supplierData.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
                            supplierData.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, supplierCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
                        }
                        dispatch(setNewSupplier(supplierData)); // set new client data
                    }
                    break;
                case "editClient":
                    selectedTemplateData = getObjectFromArrayOfObjects(CLIENTS_DATA.clientTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedClientTemplate(selectedTemplateData["0"])); // Set client selected template data
                        let clientData = JSON.parse(selectedTemplateData["0"].templateData);
                        const clientCategories = getObjectFromArrayOfObjects(CLIENTS_DATA.clientsSettings.categories, "active", "isActive");
                        const selectedCategory = findObjectFromArrayOfObjects(clientCategories, clientData.category, "_id");
                        if (selectedCategory) {
                            clientData.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
                            clientData.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, clientCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
                        }
                        dispatch(setEditClient(clientData)); // set new client data
                    }
                    break;
                case "editSupplier":
                    selectedTemplateData = getObjectFromArrayOfObjects(SUPPLIERS_DATA.supplierTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedSupplierTemplate(selectedTemplateData["0"])); // Set supplier selected template data
                        let supplierData = JSON.parse(selectedTemplateData["0"].templateData);
                        const supplierCategories = getObjectFromArrayOfObjects(SUPPLIERS_DATA.suppliersSettings.categories, "active", "isActive");
                        const selectedCategory = findObjectFromArrayOfObjects(supplierCategories, supplierData.category, "_id");
                        if (selectedCategory) {
                            supplierData.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
                            supplierData.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, supplierCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
                        }
                        dispatch(setEditSupplier(supplierData)); // set new supplier data
                    }
                    break;
                case "clientMovements":
                    selectedTemplateData = getObjectFromArrayOfObjects(CLIENTS_DATA.clientMovementsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedClientMovementsTemplate(selectedTemplateData["0"])); // Set client movements selected template data
                        dispatch(setNewClientMovements(JSON.parse(selectedTemplateData["0"].templateData))); // set new client data
                    }
                    break;
                case "supplierMovements":
                    selectedTemplateData = getObjectFromArrayOfObjects(SUPPLIERS_DATA.supplierMovementsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedSupplierMovementsTemplate(selectedTemplateData["0"])); // Set supplier movements selected template data
                        dispatch(setNewSupplierMovements(JSON.parse(selectedTemplateData["0"].templateData))); // set new supplier data
                    }
                    break;
                case "editClientMovements":
                    selectedTemplateData = getObjectFromArrayOfObjects(CLIENTS_DATA.clientMovementsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedClientMovementsTemplate(selectedTemplateData["0"])); // Set client movements selected template data
                        dispatch(setEditClientMovements(JSON.parse(selectedTemplateData["0"].templateData))); // set new client data
                    }
                    break;
                case "editSupplierMovements":
                    selectedTemplateData = getObjectFromArrayOfObjects(SUPPLIERS_DATA.supplierMovementsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedSupplierMovementsTemplate(selectedTemplateData["0"])); // Set supplier movements selected template data
                        dispatch(setEditSupplierMovements(JSON.parse(selectedTemplateData["0"].templateData))); // set new supplier data
                    }
                    break;
                case "sales":
                    selectedTemplateData = getObjectFromArrayOfObjects(SALES.salesTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedSalesTemplate(selectedTemplateData["0"])); // Set sales selected template data
                        let salesTemplateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);

                        // Passing updated time on template selection
                        salesTemplateData.date = date;
                        salesTemplateData.time = currentTime;
                        salesTemplateData.otherCorrelatedEntities = [];

                        if (salesTemplateData?.peppol && salesTemplateData?.enablePeppol === "active") {
                            if (Object.keys(salesTemplateData.peppol).length > 0) {
                                salesTemplateData.peppol.dueDate = moment().format("YYYY-MM-DD");
                            }
                        }

                        dispatch(setNewSales(salesTemplateData)); // set new sales data
                    }
                    break;
                case "quotations":
                    selectedTemplateData = getObjectFromArrayOfObjects(SALES.quotationsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedQuotationsTemplates(selectedTemplateData["0"]));
                        let quotationsTemplateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
                        // Passing updated time on template selection
                        quotationsTemplateData.date = date;
                        quotationsTemplateData.time = currentTime;
                        quotationsTemplateData.otherCorrelatedEntities = [];

                        dispatch(setNewQuotations(quotationsTemplateData)); // set new quotations data
                    }
                    break;
                case "editQuotations":
                    selectedTemplateData = getObjectFromArrayOfObjects(SALES.quotationsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedQuotationsTemplates(selectedTemplateData["0"]));
                        let quotationsTemplateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
                        // Passing updated time on template selection
                        quotationsTemplateData.date = date;
                        quotationsTemplateData.time = currentTime;
                        quotationsTemplateData.otherCorrelatedEntities = [];

                        dispatch(setEditQuotations(quotationsTemplateData)); // set new quotations data
                    }
                    break;
                case "primerAiUrl":
                    selectedTemplateData = getObjectFromArrayOfObjects(SALES.primerAiUrlTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData && selectedTemplateData.length > 0) {
                        dispatch(setSelectedPrimerAiUrlTemplates(selectedTemplateData["0"]));
                        dispatch(setNewPrimerAiUrl(JSON.parse(selectedTemplateData["0"].templateData)));
                    }
                    break;
                case "buys":
                    selectedTemplateData = getObjectFromArrayOfObjects(BUYS.buysTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedSalesTemplate(selectedTemplateData["0"])); // Set buys selected template data
                        let buysTemplateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
                        // Passing updated time on template selection
                        buysTemplateData.date = date;
                        buysTemplateData.time = currentTime;

                        dispatch(setNewBuys(buysTemplateData)); // set new buy data
                    }
                    break;
                case "clientPayments":
                    selectedTemplateData = getObjectFromArrayOfObjects(CLIENTS_DATA.clientPaymentsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedProductTemplate(selectedTemplateData['0']));
                        let templateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);

                        templateData.date = date;
                        templateData.time = currentTime;
                        dispatch(setNewClientPayment(templateData));
                    }
                    break;
                case "supplierPayments":
                    selectedTemplateData = getObjectFromArrayOfObjects(SUPPLIERS_DATA.supplierPaymentsTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedProductTemplate(selectedTemplateData['0']));
                        let templateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);

                        templateData.date = date;
                        templateData.time = currentTime;
                        dispatch(setNewSupplierPayment(templateData));
                    }
                    break;
                case "accountingClosure":
                    selectedTemplateData = getObjectFromArrayOfObjects(ACCOUNTING_DATA.accountingClosureTemplates, selectedTemplate.value, "_id");
                    if (selectedTemplateData.length > 0) {
                        dispatch(setSelectedProductTemplate(selectedTemplateData['0']));
                        let accountingClosureTemplateData = JSON.parse(selectedTemplateData["0"].templateData);
                        let date = new Date();
                        const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);

                        accountingClosureTemplateData.date = date;
                        accountingClosureTemplateData.time = currentTime;
                        if (String(company.year) !== String(moment().year())) {
                            accountingClosureTemplateData.date = moment(company.year, "YYYY").endOf("year").hour(12).toDate();
                        }

                        dispatch(setNewAccountingClosure(accountingClosureTemplateData));
                    }
                    break;
                default:
                    return [];
            }
        }
    }

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({contentRef: componentRef});

    const handleDpActions = async (action, extraData, moreExtraData) => {
        if (action === "print" || action === "printOnSave") {
            handlePrint();
        } else if (action === "sendEmailOnSave") {
            if (checkPermission("settings-generalsettings/emailsmtp-read", permissionsData)) {
                let elementsToShow;
                if (templateType === "sales" || templateType === "quotations") {
                    elementsToShow = componentRef.current.getElementsByClassName('sales-print-template');
                } else if (templateType === "clientPayments") {
                    elementsToShow = componentRef.current.getElementsByClassName('clientpayment-print-template');
                } else if (templateType === "buys") {
                    elementsToShow = componentRef.current.getElementsByClassName('buy-print-template');
                }
                if (elementsToShow.length > 0) {
                    for (let i = 0; i < elementsToShow.length; i++) {
                        let element = elementsToShow[i];
                        if (element?.id !== undefined) {
                            if (templateType === "sales" || templateType === "quotations") element.classList.add('sales-print-template-show');
                            if (templateType === "clientPayments") element.classList.add('clientpayment-print-template-show');
                            if (templateType === "buys") element.classList.add('buy-print-template-show')
                        }
                    }
                }
                let recipientEmails = [...selectedRecipientEmails, ...selectedCustomRecipientEmails];
                if (templateType === "sales") await dispatch(sendMail(componentRef.current, extraData, SETTINGS.salesEmailSettings, recipientEmails, "sale"));
                if (templateType === "quotations") await dispatch(sendMail(componentRef.current, extraData, SETTINGS.salesEmailSettings, recipientEmails, "quotation"));
                if (templateType === "clientPayments") await dispatch(sendMail(componentRef.current, extraData, SALES_SETTINGS.salesEmailSettings, recipientEmails, "clientPayment"));
                if (templateType === "buys") await dispatch(sendMail(componentRef.current, extraData, SALES_SETTINGS.salesEmailSettings, recipientEmails, "buys"));
                if (elementsToShow.length > 0) {
                    for (let i = 0; i < elementsToShow.length; i++) {
                        let element = elementsToShow[i];
                        if (element?.id !== undefined) {
                            if (templateType === "sales" || templateType === "quotations") element.classList.remove('sales-print-template-show');
                            if (templateType === "clientPayments") element.classList.remove('clientpayment-print-template-show');
                            if (templateType === "buys") element.classList.remove('buy-print-template-show');
                        }
                    }
                }
            } else {
                toast.error("You dont have the permission to send emails. Please contact Primer Software in order to get it.");
            }
        } else if (action === "convertDocument") {
            setShowConvertDocumentConfirmation(true);
        } else if (action === "convertQuotation") {
            setShowConvertQuotationConfirmation(true);
        } else if (action === "issueCreditDocument") {
            setShowIssueCreditDocumentConfirmation(true);
        } else if (action === "cancelMyDataInvoice") {
            setShowCancelDocumentConfirmation(true);
        } else if ((action === "save" || action === "saveandrepeat") && templateType !== "undefined") {
            if (templateType === "product") { // Save Product
                const productData = PRODUCTS_DATA.selectedProduct;
                const validation = validateProductObject(productData);

                if (!validation.success) return toast.error(validation.message);

                const postProductData = { ...requestData, ...productData };
                if (postProductData.measurementUnit === "4" && !isEmpty(postProductData.taricNumber)) postProductData.taricNumber = "";

                if (action === 'save') {
                    dispatch(postProduct(postProductData, requestData, setLoadingSave, true, onSuccess));
                } else if (action === 'saveandrepeat') {
                    dispatch(postProduct(postProductData, requestData, setLoadingSaveAndRepeat, false, onSuccess));
                }
            } else if (templateType === "editProduct") { // Update Product
                const editProductData = PRODUCTS_DATA.selectedEditProduct[tabKey];
                const validation = validateEditProductObject(editProductData);

                if (!validation.success) return toast.error(validation.message);
                if (!ACTIVITY.saveEditProduct) dispatch(setSaveEditProduct(true));

                const postProductData = { ...requestData, ...editProductData };
                postProductData.packagingQuantity = !isEmpty(postProductData.packagingQuantity) ? String(postProductData.packagingQuantity) : "";
                postProductData.packagingType = !isEmpty(postProductData.packagingType) ? String(postProductData.packagingType) : "";
                postProductData.otherPackagingTypeTitle = postProductData.otherPackagingTypeTitle || "";
                if (postProductData.measurementUnit === "4" && !isEmpty(postProductData.taricNumber)) postProductData.taricNumber = "";

                dispatch(putProduct(postProductData, requestData, "update", false, setLoadingSave, onSuccess));
            } else if (templateType === "productMovements") { // Save Product Movements
                const movementData = PRODUCTS_DATA.newProductMovements;
                const validation = validateProductMovementObject(movementData, company);

                if (!validation.success) return toast.error(validation.message);
                if (!ACTIVITY.saveNewProductMovements) dispatch(setSaveNewProductMovements(true));

                const requestDatapm = {
                    isActive: "active",
                    company: company.id,
                    year: company.year.toString(),
                }

                const postProductMovementsData = {...movementData, ...requestDatapm};
                dispatch(postProductMovements(postProductMovementsData, isEmronConnectFileERP, setLoadingSave, onSuccess));
            } else if (templateType === "editProductMovements") { // Edit Product Movements
                const movementData = PRODUCTS_DATA.editProductMovements;
                const validation = validateProductMovementObject(movementData, company);

                if (!validation.success) return toast.error(validation.message);
                const requestDatapm = {
                    isActive: "active",
                    company: company.id,
                    year: company.year.toString(),
                };

                const editProductMovementsData = {...movementData, ...requestDatapm};
                dispatch(putProductMovements(editProductMovementsData, setLoadingSave, onSuccess));
            } else if (templateType === "priceList") { // Save Price List
                const priceListData = PRODUCTS_DATA.newPriceList;
                const validation = validatePriceListObject(priceListData);
                if (!validation.success) return toast.error(validation.message);
                if (!ACTIVITY.saveNewPriceList) dispatch(setSaveNewPriceList(true));

                const postPriceListData = {...requestData, ...priceListData,};

                if (action === "save") {
                    if (postPriceListData._id) {
                        dispatch(putPriceList(postPriceListData, requestData, "update", setLoadingSave, setActivePriceListModal, onSuccess));
                    } else {
                        dispatch(postPriceList(postPriceListData, requestData, true, setLoadingSave, setActivePriceListModal, onSuccess));
                    }
                } else if (action === "saveandrepeat") {
                    postPriceListData.isActive = "inactive";
                    if (postPriceListData._id) {
                        dispatch(putPriceList(postPriceListData, requestData, "update", setLoadingSave, setActivePriceListModal, onSuccess));
                    } else {
                        dispatch(postPriceList(postPriceListData, requestData, false, setLoadingSave, setActivePriceListModal, onSuccess));
                    }
                }
            } else if (templateType === "editPriceList") { // Update Price List
                const priceListData = PRODUCTS_DATA.editPriceList;
                const validation = validatePriceListObject(priceListData);
                if (!validation.success) return toast.error(validation.message);
                let postPriceListData = {...requestData, ...priceListData};

                dispatch(putPriceList(postPriceListData, requestData, "update", setLoadingSave, setActivePriceListModal, onSuccess));
            } else if (templateType === "basicType") { // Save Basic Type
                const postBasicTypeData = {...SETTINGS.settings.newBasicType, ...requestData};
                dispatch(postBasicType(postBasicTypeData, setLoadingSave, onSuccess)); // Post Basic Type to API
            } else if (templateType === "editBasicType") {  // Update Basic Type
                const editBasicTypeData = {...SETTINGS.settings.editBasicType, ...requestData};
                dispatch(putBasicType(editBasicTypeData, requestData, setLoadingSave, onSuccess)); // Post Basic Type to API
            } else if (templateType === "advancedType") { // Save Advanced Type
                const advancedTypeData = SETTINGS.settings.newAdvancedType;
                const validation = validateAdvancedTypeObject(advancedTypeData);
                if (!validation.success) return toast.error(validation.message);

                const finalData = { ...requestData, ...advancedTypeData };

                if (finalData.section === "Sales") {
                    dispatch(postAdvancedTypeSales(finalData, setLoadingSave, onSuccess));
                } else if (finalData.section === "Buys") {
                    dispatch(postAdvancedTypeBuys(finalData, setLoadingSave, onSuccess));
                } else {
                    dispatch(postAdvancedType(finalData, setLoadingSave, onSuccess));
                }
            } else if (templateType === "editAdvancedType") { // Update Advanced Type
                const advancedTypeData = SETTINGS.settings.editAdvancedType;
                const validation = validateAdvancedTypeObject(advancedTypeData);
                if (!validation.success) return toast.error(validation.message);

                let putAdvancedTypeData = { ...requestData, ...advancedTypeData };

                if (putAdvancedTypeData.section === "Sales") {
                    dispatch(putAdvancedTypeSales(putAdvancedTypeData, setLoadingSave, onSuccess));
                } else if (putAdvancedTypeData.section === "Buys") {
                    dispatch(putAdvancedTypeBuys(putAdvancedTypeData, setLoadingSave, onSuccess));
                } else {
                    dispatch(putAdvancedType(putAdvancedTypeData, setLoadingSave, onSuccess));
                }
            } else if (templateType === "client") { // Save Client
                const validationResponse = validateNewClientObject(CLIENTS_DATA.newClient, company.vatNumber);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                // Client Data
                let postClientData = {...CLIENTS_DATA.newClient, ...requestData};
                postClientData.isActive = CLIENTS_DATA.newClient.isActive; // set status
                // Client Emron Data
                let postClientEmronData = {...CLIENTS_DATA.clientEmron, ...requestData};
                postClientEmronData.isActive = CLIENTS_DATA.clientEmron.isActive; // set status
                if (action === "save") {
                    if (postClientData.isActive === "draft") {
                        dispatch(putClient(postClientData, requestData, "update", {}, true, setLoadingSave, onSuccess)); // Update Client To API
                    } else {
                        dispatch(postClient(postClientData, requestData, postClientEmronData, true, setLoadingSave, onSuccess)); // Post Client To API
                    }
                }
                if (action === "saveandrepeat") {
                    postClientData.isActive = "draft";
                    dispatch(postClient(postClientData, requestData, postClientEmronData, false, setLoadingSaveAndRepeat, onSuccess)); // Post Client To API
                }
            } else if (templateType === "supplier") { // Save Supplier
                const supplierData = SUPPLIERS_DATA.newSupplier;
                const validation = validateSupplierObject(supplierData);
                if (!validation.success) return toast.error(validation.message);

                let postSupplierData = { ...supplierData, ...requestData };
                postSupplierData.isActive = supplierData.isActive;

                let postSupplierEmronData = {
                    ...SUPPLIERS_DATA.supplierEmron,
                    ...requestData,
                    isActive: SUPPLIERS_DATA.supplierEmron.isActive
                };

                if (action === "save") {
                    setLoadingSave(true);
                    if (postSupplierData.isActive === "draft" || postSupplierData._id) {
                        dispatch(putSupplier(postSupplierData, requestData, setLoadingSave, onSuccess));
                    } else {
                        dispatch(postSupplier(postSupplierData, requestData, postSupplierEmronData, true, setLoadingSave, onSuccess));
                    }
                } else if (action === "saveandrepeat") {
                    setLoadingSaveAndRepeat(true);
                    postSupplierData.isActive = "draft";
                    dispatch(postSupplier(postSupplierData, requestData, postSupplierEmronData, setLoadingSaveAndRepeat, onSuccess));
                }
            } else if (templateType === "editClient") { // Edit Client
                let editClientData = CLIENTS_DATA.editClient[tabKey];
                const validation = validateEditClientObject(editClientData, company.vatNumber);
                if (!validation.success) return toast.error(validation.message);

                let canProceed = true;
                if (company.vatNumber === "800434990" && getCurrentUser()?.userType === "Admin" && !emronAdminCancellationModal) {
                    try {
                        const preCheckResponse = await axios.post(`${process.env.REACT_APP_API_URL2}/emron/client-edit-pre-check`, {...editClientData}, {
                            headers: { 'Content-Type': 'application/json' },
                        });
                        if (preCheckResponse.data.status === "418") {
                            canProceed = false;
                            setEmronAdminCancellationModal(true);
                        } else if (preCheckResponse.data.status !== "200") {
                            toast.error(preCheckResponse.data.message);
                        }
                    } catch (error) {
                        console.log(error);
                        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                    }
                }
                if (canProceed) {
                    if (emronAdminCancellationModal) setEmronAdminCancellationModal(false);

                    // Client Data
                    let postClientData = {...editClientData, ...requestData};
                    postClientData.isActive = editClientData.isActive; // set status
                    if (ACTIVITY.saveEditClientInWholeSystem) postClientData.saveClientInWholeSystem = true;

                    // Client Emron Data
                    let postClientEmronData = {...CLIENTS_DATA.clientEmron, ...requestData,};
                    postClientEmronData.isActive = CLIENTS_DATA.clientEmron.isActive; // set status

                    setLoadingSave(true);
                    dispatch(putClient(postClientData, requestData, "update", {}, true, setLoadingSave, onSuccess)); // Update Client To API
                }
            } else if (templateType === "editSupplier") { // Edit Supplier
                const editSupplierData = SUPPLIERS_DATA.editSupplier[tabKey];
                const validation = validateEditSupplierObject(editSupplierData, company.vatNumber);

                if (!validation.success) return toast.error(validation.message);

                // Supplier Data
                let postSupplierData = {...editSupplierData, ...requestData};
                postSupplierData.isActive = editSupplierData.isActive; // set status

                // Supplier Emron Data
                let postSupplierEmronData = {...SUPPLIERS_DATA.supplierEmron, ...requestData,};
                postSupplierEmronData.isActive = SUPPLIERS_DATA.supplierEmron.isActive; // set status
                dispatch(putSupplier(postSupplierData, requestData, setLoadingSave, onSuccess)); // Update Supplier To API
            } else if (templateType === "clientsSettings") { // Save Client Settings
                let postClientsSetting = {...CLIENTS_DATA.clientsSettings, ...requestData}
                dispatch(postClientsSettings(postClientsSetting, requestData, setLoadingSave, onSuccess)); // Post Client Settings To API
            } else if (templateType === "suppliersSettings") { // Save Supplier Settings
                let postSuppliersSetting = {...SUPPLIERS_DATA.suppliersSettings, ...requestData,};
                dispatch(postSuppliersSettings(postSuppliersSetting, requestData, setLoadingSave, onSuccess)); // Post Supplier Settings To API
            } else if (templateType === "clientMovements") { // Save Client Movements
                const movementData = CLIENTS_DATA.newClientMovements;
                const validation = validateClientMovementObject(movementData, company);
                if (!validation.success) return toast.error(validation.message);

                let postClientMovementsData = {...movementData, ...requestData};
                dispatch(postClientMovements(postClientMovementsData, isEmronConnectFileERP, setLoadingSave, onSuccess)); // Post Client Movement To API
            } else if (templateType === "editClientMovements") {
                const editMovementData = CLIENTS_DATA.editClientMovements;
                const validation = validateClientMovementObject(editMovementData, company);
                if (!validation.success) return toast.error(validation.message);

                let postClientMovementsData = {...CLIENTS_DATA.editClientMovements, ...requestData};
                dispatch(putClientMovements(postClientMovementsData, setLoadingSave, onSuccess)); // Post Client Movement To API
            } else if (templateType === "supplierMovements") {
                const movementData = SUPPLIERS_DATA.newSupplierMovements;
                const validation = validateSupplierMovementObject(movementData, company);
                if (!validation.success) return toast.error(validation.message);

                let postSupplierMovementsData = {...SUPPLIERS_DATA.newSupplierMovements, ...requestData};
                dispatch(postSupplierMovements(postSupplierMovementsData, isEmronConnectFileERP, setLoadingSave, onSuccess)); // Post Supplier Movement To API
                dispatch(setNewSupplierMovements(SUPPLIERS_DATA.supplierMovementsInitialValues)); // Reset supplier form
            } else if (templateType === "editSupplierMovements") {
                const editMovementData = SUPPLIERS_DATA.editSupplierMovements;
                const validation = validateSupplierMovementObject(editMovementData, company);
                if (!validation.success) return toast.error(validation.message);

                let postSupplierMovementsData = {...SUPPLIERS_DATA.editSupplierMovements, ...requestData};
                dispatch(putSupplierMovements(postSupplierMovementsData, setLoadingSave, onSuccess)); // Post Supplier Movement To API
            } else if (templateType === "settingsPrimeData") { // Save My Data Data Taxes
                if (SETTINGS.primerMyDataData) {
                    let pMDDSettings = Object.assign({}, SETTINGS.primerMyDataData);
                    if ("_id" in pMDDSettings) delete pMDDSettings._id;
                    if ("__v" in pMDDSettings) delete pMDDSettings.__v;
                    const currentUser = getCurrentUser();
                    const cUserID = currentUser._id;
                    let pMDDRequestData = {
                        year: requestData?.year, company: requestData?.company, userId: cUserID
                    };
                    pMDDSettings = {...pMDDSettings, ...pMDDRequestData};
                    dispatch(putPrimerMyDataData(pMDDSettings, onSuccess));
                }
            } else if (templateType === "settingsEmailSmtp") { // Save email SMTP
                if (SETTINGS.emailSmtp) {
                    let smtpSettings = Object.assign({}, SETTINGS.emailSmtp);
                    if (smtpSettings.smtpOption !== "" && smtpSettings.username !== "" && smtpSettings.password !== "" && smtpSettings.encryptionType !== "" && smtpSettings.smtpAuthentication !== "" && smtpSettings.subject !== "" && smtpSettings.smtpAuthentication !== "") {

                    }
                    if ("_id" in smtpSettings) delete smtpSettings._id;
                    if ("__v" in smtpSettings) delete smtpSettings.__v;
                    let pMDDRequestData = {company: requestData?.company,};
                    smtpSettings = {...smtpSettings, ...pMDDRequestData};
                    dispatch(putCompanyEmailSmtp(smtpSettings, onSuccess));
                }
            } else if (templateType === "cashRegisters") { // Save Cash Registers
                const cashRegisterData = CASH_DATA.newCashRegisters;
                const validation = validateCashRegisterObject(cashRegisterData);
                if (!validation.success) return toast.error(validation.message);

                let postCashRegisterData = {...cashRegisterData, ...requestData,};
                postCashRegisterData.isActive = cashRegisterData.isActive;
                if (action === "save") {
                    setLoadingSave(true);
                    dispatch(setNewCashRegisters(CASH_DATA.newCashRegistersInitialValue));

                    if (postCashRegisterData.isActive === "draft") {
                        dispatch(putCashRegisters(postCashRegisterData, requestData, setLoadingSave, onSuccess));
                        dispatch(setSaveEditCashRegister(false));
                    } else {
                        dispatch(postCashRegisters(postCashRegisterData, requestData, setLoadingSave, onSuccess));
                        dispatch(setSaveNewCashRegister(false));
                    }
                } else if (action === "saveandrepeat") {
                    setLoadingSaveAndRepeat(true);
                    postCashRegisterData.isActive = "draft";
                    dispatch(postCashRegisters(postCashRegisterData, requestData, setLoadingSaveAndRepeat, onSuccess));
                    dispatch(setSaveNewCashRegister(false));
                }
            } else if (templateType === "editCashRegisters") { // Update Cash Registers
                const cashRegisterData = CASH_DATA.editCashRegisters;
                const validation = validateCashRegisterObject(cashRegisterData);

                if (!validation.success) return toast.error(validation.message);
                if (action === "save") {
                    let editCashRegisterData = {...cashRegisterData, ...requestData};
                    editCashRegisterData.isActive = cashRegisterData.isActive;
                    setLoadingSave(true);
                    dispatch(putCashRegisters(editCashRegisterData, requestData, setLoadingSave, onSuccess));
                    dispatch(setSaveEditCashRegister(false));
                }
            } else if (templateType === "bankAccounts") { // Save Bank Accounts
                const bankAccountData = CASH_DATA.newBankAccount;
                const validation = validateBankAccountObject(bankAccountData);

                if (!validation.success) return toast.error(validation.message);
                let postBankAccountData = {...bankAccountData, ...requestData,};
                postBankAccountData.isActive = bankAccountData.isActive;

                if (action === "save") {
                    setLoadingSave(true);
                    if (postBankAccountData.isActive === "draft") {
                        dispatch(putBankAccounts(postBankAccountData, requestData, setLoadingSave, onSuccess));
                        dispatch(setSaveEditBankAccounts(false));
                    } else {
                        dispatch(postBankAccounts(postBankAccountData, requestData, setLoadingSave, onSuccess));
                        dispatch(setSaveNewBankAccounts(false));
                    }
                }
            } else if (templateType === "editBankAccounts") { // Update Bank Accounts
                const bankAccountData = CASH_DATA.editBankAccount;
                const validation = validateBankAccountObject(bankAccountData);

                if (!validation.success) return toast.error(validation.message);
                if (action === "save") {
                    let finalEditBankAccountData = {...bankAccountData, ...requestData};
                    finalEditBankAccountData.isActive = bankAccountData.isActive;
                    setLoadingSave(true);
                    dispatch(putBankAccounts(finalEditBankAccountData, requestData, setLoadingSave, onSuccess));
                    dispatch(setSaveEditBankAccounts(false));
                }
            } else if (templateType === "cashAccountingSettings") {
                const postData = {...CASH_DATA.cashSettings, company: requestData.company}
                dispatch(postCashSettings(postData, setLoadingSave, onSuccess));
                dispatch(setSaveCashAccountingSettings(false));
            } else if (templateType === "POS") { // Save POS
                const posData = CASH_DATA.newPOS;
                const validation = validatePOSObject(posData);
                if (!validation.success) return toast.error(validation.message);

                let postPOSData = {...posData, ...requestData};
                postPOSData.isActive = posData.isActive;

                if (action === "save") {
                    setLoadingSave(true);
                    dispatch(postPOS(postPOSData, requestData, setLoadingSave, onSuccess));
                    dispatch(setSaveNewPOS(false));
                }
            } else if (templateType === "editPOS") { // Update POS
                const posData = CASH_DATA.editPOS;
                const validation = validatePOSObject(posData);

                if (!validation.success) return toast.error(validation.message);
                if (action === "save") {
                    let editPOSRequestData = {...posData, ...requestData};
                    editPOSRequestData.isActive = posData.isActive;
                    setLoadingSave(true);
                    dispatch(putPOS(editPOSRequestData, requestData, setLoadingSave, onSuccess));
                    dispatch(setSaveEditPOS(false));
                }
            } else if (templateType === "salesGeneralSettings") { // Save Sales General and Email
                const settingsData = SALES_SETTINGS.salesGeneralSettings;
                const validation = validateSalesSettingsObject(settingsData);

                if (!validation.success) return toast.error(validation.message);
                let postSalesGeneralSettingsData = {...settingsData, ...requestData};

                if (postSalesGeneralSettingsData._id) {
                    setLoadingSave(true);
                    dispatch(putSalesGeneralSettings(postSalesGeneralSettingsData, requestData, setLoadingSave, onSuccess));
                } else {
                    dispatch(postSalesGeneralSettings(postSalesGeneralSettingsData, requestData, onSuccess));
                }
                dispatch(setSaveSalesSettings(false));
            } else if (templateType === "buysGeneralSettings") { // Save Buys General and Email
                const settingsData = BUYS_SETTINGS.buysGeneralSettings;
                const validation = validateBuysSettingsObject(settingsData);
                if (!validation.success) return toast.error(validation.message);
                let postBuysGeneralSettingsData = {...settingsData, ...requestData};
                if (postBuysGeneralSettingsData._id) {
                    setLoadingSave(true);
                    dispatch(putBuysGeneralSettings(postBuysGeneralSettingsData, requestData, setLoadingSave, onSuccess));
                } else {
                    dispatch(postBuysGeneralSettings(postBuysGeneralSettingsData, requestData, onSuccess));
                }
                dispatch(setSaveBuysSettings(false));
            } else if (templateType === "sales") { // Save Sales
                dispatch(setSaveSales(false));

                const newSalesData = {...SALES.newSales};
                const validationResponse = await validateSaleObject(newSalesData, company, SETTINGS, SALES_SETTINGS);
                if (!validationResponse.success) {
                    dispatch(setSaveSales(true));
                    return toast.error(validationResponse.message);
                }

                if ((action === "save" || action === "saveandrepeat") && validationResponse.success) {
                    let postSalesData = structuredClone({...SALES.newSales, ...requestData});

                    if (postSalesData.enablePeppol === "active") {
                        for (const prod of postSalesData.products) {
                            if (isEmpty(prod.cpvCode)) prod.cpvCode = "00000000-0";
                        }
                    }

                    if (action === "saveandrepeat") postSalesData.isActive = "draft";

                    const advDoc = SETTINGS.settings.advancedTypesSales.filter((doc) => doc._id === postSalesData.documentType);
                    if (postSalesData.customTime !== "true") {
                        let date = new Date();
                        postSalesData.date = date;
                        postSalesData.time = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
                    }
                    if (!isDeliveryNoteTypes.includes(newSalesData.myDataType)) delete postSalesData.isDeliveryNote;
                    if (postSalesData.numberingMode === "automatic") {
                        let checkAtParams = {};
                        checkAtParams.company = company.id;
                        checkAtParams.id = !postSalesData.documentType ? postSalesData.newSales.documentType : postSalesData.documentType;
                        checkAtParams.preNumber = !postSalesData.preNumber ? postSalesData.newSales.preNumber : postSalesData.preNumber;
                        checkAtParams.installation = !postSalesData.installation ? postSalesData.newSales?.installation?.toString() : postSalesData?.installation?.toString();
                        if (checkAtParams.id && checkAtParams.preNumber && checkAtParams.installation) {
                            await axios.post(apiURL2 + `/settings/add-setting-advance-type-check-sale`, checkAtParams, {
                                headers: {'Content-Type': 'application/json'}
                            }).then((res) => {
                                if (res.data && res.data.status === '200') {
                                    if (res.data.number !== undefined) {
                                        postSalesData.number = parseInt(res.data.number) + 1;
                                    }
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                        }
                    }
                    let printAfterSave = advDoc[0] && advDoc[0]?.printAfterSave === "active";
                    const loadingSetter = action === "save" ? setLoadingSave : setLoadingSaveAndRepeat;

                    if (postSalesData._id) {
                        dispatch(putSales(postSalesData, loadingSetter)); // Post to API
                    } else {
                        if (advDoc[0]?.mydataProvider === "active" || advDoc[0]?.enableMyData === "active") { // Pre-construct UID
                            const formatPreNumber = postSalesData.preNumber === "noprefix" ? "0" : postSalesData.preNumber;
                            postSalesData.uid = generateMyDataUID(company.vatNumber, moment(postSalesData.date).utc().format("YYYY-MM-DD"), postSalesData.installation, postSalesData.myDataType, formatPreNumber, postSalesData.number);
                        }
                        if (SALES.newSales.myDataPaymentId === "7" && !isEmpty(SALES.newSales.myDataType) && advDoc[0]?.mydataProvider === "active" && SALES.newSales?.myDataType !== "5.1"
                            && SALES.newSales?.myDataType !== "5.2" && SALES.newSales?.myDataType !== "11.4") {
                            const findPOS = CASH_DATA.posList.find((el) => el._id === SALES.newSales.bankAccount);
                            if (findPOS && (findPOS.isETameiaki === "active" || findPOS?.isWebECR === "true")) {
                                setShowPOSModal(true);
                                setShowPOSModalText("Η πληρωμή στάλθηκε. Παρακαλώ ελέγξτε το POS.")
                                try {
                                    const request = await axios.post(process.env.REACT_APP_API_URL2 + "/sale/pos-payment", {
                                        company: company.id,
                                        pos: findPOS._id,
                                        amount: SALES.newSales.paymentAmount,
                                        transactionAmount: SALES.newSales.paymentAmount,
                                        netValue: SALES.newSales.totalNetValue,
                                        vatValue: SALES.newSales.totalVatValue,
                                        myDataType: postSalesData.myDataType,
                                        preNumber: postSalesData.preNumber,
                                        number: postSalesData.number,
                                        installation: postSalesData.installation,
                                        tipAmount: SALES.newSales.tipAmount,
                                        saleObject: postSalesData,
                                    });
                                    setShowPOSModal(false);
                                    setShowPOSModalText("");
                                    if (request.data && request.data.status === "200") {
                                        if (onSuccess) onSuccess();
                                        if (isEmronConnectFileERP) {
                                            localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${request.data.saleData._id}|${getDocumentLabel(request.data.saleData)}`);
                                            return window.close();
                                        }
                                        await dispatch(setNewSales(request.data.saleData));
                                        if (printAfterSave === true) await handleDpActions("printOnSave");
                                        if (ACTIVITY?.sendEmail === "active") await handleDpActions("sendEmailOnSave", request.data.saleData);
                                        if (DCL?.showDclAfterSaleNew || DCL?.showDclPageAfterSaleNew) {
                                            dispatch(removeTab("sales-new"));
                                            const returnTab = DCL?.showDclAfterSaleNew ? "new-dcl" : "edit-dcl";
                                            dispatch(openTabByType(returnTab, TABS_DATA));
                                            dispatch(setShowDclAfterSaleNew(false));
                                            dispatch(setShowDclPageAfterSaleNew(false));
                                            dispatch(setForceRefreshDclActive(true));
                                            dispatch(addToForceRefresh("Dcl Search"));
                                            if (returnTab === "edit-dcl") dispatch(setRefreshEditDcl(true));
                                            if (returnTab === "new-dcl") dispatch(setRefreshSelectedDcl(true));
                                        }

                                        if (action === "saveandrepeat") {
                                            setTimeout(async () => {
                                                let draftSale = JSON.parse(JSON.stringify(request.data.saleData));
                                                let date = new Date();
                                                const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
                                                // Passing updated time on template selection
                                                draftSale.date = date;
                                                draftSale.time = currentTime;
                                                draftSale.number = "";
                                                draftSale._id = undefined;
                                                draftSale.myDataStatus = "not_sent";
                                                draftSale.transmissionFailure = undefined;
                                                draftSale.mark = undefined;
                                                draftSale.uid = undefined;
                                                draftSale.authCode = undefined;
                                                draftSale.myDataRequest = undefined;
                                                draftSale.myDataEnvironment = undefined;
                                                draftSale.myDataError = undefined;
                                                draftSale.myDataDestination = undefined;
                                                draftSale.transactionDetails = undefined;
                                                draftSale.linkedClientPayments = undefined;
                                                let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, draftSale.documentType, '_id');
                                                let selectedDocumentTypeData = dtData['0'];
                                                let selectedInstallation = getObjectFromArrayOfObjects(selectedDocumentTypeData['documentNumbering'], draftSale.installation, "installationMasterId");
                                                let selectedInstallationNumbering = selectedInstallation.filter(selected => selected.preNumber === draftSale.preNumber);
                                                if (Object.keys(selectedInstallation).length > 0 && selectedInstallationNumbering.length > 0) {
                                                    draftSale.number = selectedInstallationNumbering[0].number + 1;
                                                } else {
                                                    draftSale.number = "";
                                                }
                                                await dispatch(resetNewSales());
                                                await dispatch(setNewSales(draftSale));
                                                await dispatch(setSaveSales(true));
                                                await dispatch(fetchAdvancedTypesSales({company: company.id}));
                                            }, 100)
                                        } else {
                                            dispatch(setSaveSales(false));
                                            dispatch(fetchAdvancedTypesSales({company: company.id}));
                                            setTimeout(() => {
                                                dispatch(resetNewSales());
                                            }, 100)
                                        }
                                        toast.success(request.data.message);
                                        if(request.data.saleData?.correlatedDclError) {
                                            toast.error("Η Συσχέτιση Εγγραφής Ψηφιακού Πελατολογίου απέτυχε: " + request.data.saleData.correlatedDclError);
                                        }
                                    } else {
                                        console.log(request.data.message);
                                        toast.error(request.data.message, {autoClose: 15000});
                                        dispatch(setSaveSales(true));
                                    }
                                } catch (error) {
                                    toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                                    dispatch(setSaveSales(true));
                                }
                                return;
                            }
                        }
                        dispatch(postSales(postSalesData, company.id, handleDpActions, printAfterSave, ACTIVITY?.sendEmail, loadingSetter, SETTINGS.settings.advancedTypesSales, isEmronConnectFileERP, DCL?.showDclAfterSaleNew, DCL?.showDclPageAfterSaleNew, TABS_DATA, onSuccess)); // Post to API
                    }
                }
            } else if (templateType === "quotations") { // Save Quotations
                dispatch(setSaveQuotations(false));

                const newQuotationsData = {...SALES.newQuotations};
                const validationResponse = await validateQuotationObject(newQuotationsData, company, SETTINGS, SALES_SETTINGS);
                if (!validationResponse.success) {
                    dispatch(setSaveQuotations(true));
                    return toast.error(validationResponse.message);
                }

                if ((action === "save" || action === "saveandrepeat") && validationResponse.success) {
                    let postQuotationsData = structuredClone({...SALES.newQuotations, ...requestData});
                    if (action === "saveandrepeat") postQuotationsData.isActive = "draft";

                    const advDoc = SETTINGS.settings.advancedTypes.filter((doc) => doc._id === postQuotationsData.documentType);
                    if (postQuotationsData.customTime !== "true") {
                        let date = new Date();
                        postQuotationsData.date = date;
                        postQuotationsData.time = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
                    }
                    if (postQuotationsData.numberingMode === "automatic") {
                        let checkAtParams = {};
                        checkAtParams.company = company.id;
                        checkAtParams.id = !postQuotationsData.documentType ? postQuotationsData.newQuotations.documentType : postQuotationsData.documentType;
                        checkAtParams.preNumber = !postQuotationsData.preNumber ? postQuotationsData.newQuotations.preNumber : postQuotationsData.preNumber;
                        checkAtParams.installation = !postQuotationsData.installation ? postQuotationsData.newQuotations?.installation?.toString() : postQuotationsData?.installation?.toString();
                        if (checkAtParams.id && checkAtParams.preNumber && checkAtParams.installation) {
                            await axios.post(apiURL2 + `/settings/add-setting-advance-type-check`, checkAtParams, {
                                headers: {'Content-Type': 'application/json'}
                            }).then((res) => {
                                if (res.data && res.data.status === '200') {
                                    if (res.data.number !== undefined) {
                                        postQuotationsData.number = parseInt(res.data.number) + 1;
                                    }
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                        }
                    }
                    let printAfterSave = advDoc[0] && advDoc[0]?.printAfterSave === "active";
                    const loadingSetter = action === "save" ? setLoadingSave : setLoadingSaveAndRepeat;

                    if (postQuotationsData._id) dispatch(putQuotations(postQuotationsData, loadingSetter)); // Post to API
                    dispatch(postQuotations(postQuotationsData, company.id, handleDpActions, printAfterSave, ACTIVITY?.sendEmail, loadingSetter, SETTINGS.settings.advancedTypes, TABS_DATA, onSuccess))
                }
            } else if (templateType === "buys") { // Save Buys
                const validationResponse = validateBuyObject(BUYS.newBuys, company, SETTINGS, BUYS_SETTINGS);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                if (action === "save") {
                    // Clear for only on save not saveandrepeat
                    let postBuysData = {...BUYS.newBuys, ...requestData};
                    const advDoc = SETTINGS.settings.advancedTypesBuys.filter((doc) => doc._id === postBuysData.documentType);
                    if (postBuysData.customTime !== "true") {
                        let date = new Date();
                        postBuysData.time = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
                    }
                    let printAfterSave = advDoc[0] && advDoc[0]?.printAfterSave === "active";
                    if (postBuysData._id) {
                        dispatch(putBuys(postBuysData, setLoadingSave, onSuccess)); // Post to API
                    } else {
                        postBuysData.date = moment(postBuysData.date).set({hour: Number(moment().format("HH")), minute: Number(moment().format("mm")), second: Number(moment().format("ss"))}).toDate();
                        // Show print preview on save
                        dispatch(postBuys(postBuysData, requestData, handleDpActions, printAfterSave, setLoadingSave, SETTINGS.settings.advancedTypesBuys, ACTIVITY?.sendEmail, isEmronConnectFileERP, onSuccess)); // Post to API
                    }
                }
                if (action === "saveandrepeat") {
                    let postBuysData = {...BUYS.newBuys, ...requestData};
                    if (postBuysData.customTime !== "true") {
                        let date = new Date();
                        postBuysData.time = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
                    }
                    const advDoc = SETTINGS.settings.advancedTypesBuys.filter((doc) => doc._id === postBuysData.documentType);
                    let printAfterSave = advDoc[0] && advDoc[0]?.printAfterSave === "active";
                    if (postBuysData._id) {
                        dispatch(putBuys(postBuysData, setLoadingSaveAndRepeat, onSuccess)); // Post to API
                    } else {
                        // Show print preview on save
                        dispatch(postBuys(postBuysData, requestData, handleDpActions, printAfterSave, setLoadingSaveAndRepeat, SETTINGS.settings.advancedTypesBuys, ACTIVITY?.sendEmail, isEmronConnectFileERP, onSuccess)); // Post to API
                    }
                }
            } else if (templateType === "editSales") { // Update Sales
                const editSaleData = SALES.editSales[tabKey];
                validateEditSaleObject(editSaleData, company, SETTINGS).then((validation) => {
                    if (!validation.success) return toast.error(validation.message);
                    let postSalesData = {...editSaleData, ...requestData};

                    setLoadingSave(true);
                    dispatch(putSales(postSalesData, setLoadingSave, onSuccess));
                });
            } else if (templateType === "editQuotations") { // Update Quotations
                const quotationData = SALES.editQuotations[tabKey];
                if (!quotationData) return toast.error("Could not find quotation data to save.");

                validateEditQuotationObject(quotationData, company).then((validation) => {
                    if (!validation.success) return toast.error(validation.message);
                    let postQuotationsData = {...quotationData, ...requestData};

                    setLoadingSave(true);
                    dispatch(putQuotations(postQuotationsData, setLoadingSave, onSuccess));
                    if (ACTIVITY.saveEditQuotations) dispatch(setSaveEditQuotations(false));
                });
            } else if (templateType === "editBuys") { // Update Buys
                const validationResponse = validateBuyObject(BUYS.editBuys, company, SETTINGS, BUYS_SETTINGS);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                if (action === "save") {
                    const postBuysData = {...BUYS.editBuys, ...requestData};
                    if (postBuysData._id) dispatch(putBuys(postBuysData, setLoadingSave, onSuccess));
                }
            } else if (templateType === "clientPayments") {
                const paymentData = CLIENTS_DATA.newClientPayment;
                const validation = validateClientPayment(paymentData, company, SETTINGS);
                if (!validation.success) return toast.error(validation.message);

                let postClientPaymentData = { ...paymentData, ...requestData };
                const advDoc = SETTINGS.settings.advancedTypes.find(doc => doc._id === paymentData.documentType);
                const printAfterSave = advDoc?.printAfterSave === "active";
                const isProviderActive = advDoc?.mydataProvider === "active";
                const triggerPosModals = () => {
                    if (isProviderActive && paymentData.paymentTypeType === "pos") {
                        if (paymentData.myDataType === "8.4") setShowPOSModal(true);
                        else if (paymentData.myDataType === "8.5") setShowPOSModalCancel(true);
                    } else if (paymentData.openPOS === "true" && paymentData.paymentTypeType === "pos") {
                        setShowPOSModal(true);
                    }
                };

                postClientPaymentData.date = moment(postClientPaymentData.date).set({
                    hour: moment().hour(), minute: moment().minute(), second: moment().second()
                }).toDate();

                if (action === "save") {
                    if (paymentData.isActive === "draft" || paymentData._id) {
                        setLoadingSave(true);
                        dispatch(putClientPayment(postClientPaymentData, setLoadingSave, onSuccess));
                        dispatch(setSaveEditClientPayments(false));
                    } else {
                        triggerPosModals();
                        setLoadingSave(true);
                        dispatch(postClientPayment(postClientPaymentData, requestData, setLoadingSave, handleDpActions, printAfterSave, false, ACTIVITY?.sendEmail, setShowPOSModal, setShowPOSModalCancel, isEmronConnectFileERP, onSuccess));
                        dispatch(setSaveClientPayments(false));
                    }
                } else if (action === "saveandrepeat") {
                    triggerPosModals();
                    setLoadingSaveAndRepeat(true);
                    dispatch(postClientPayment(postClientPaymentData, requestData, setLoadingSaveAndRepeat, handleDpActions, printAfterSave, true, ACTIVITY?.sendEmail, setShowPOSModal, setShowPOSModalCancel, isEmronConnectFileERP, onSuccess));
                    dispatch(setSaveClientPayments(false));
                }
            } else if (templateType === "editClientPayments") {
                const editPaymentData = CLIENTS_DATA.editClientPayment;
                const validation = validateClientPayment(editPaymentData, company, SETTINGS);
                if (!validation.success) return toast.error(validation.message);

                const postEditData = {...editPaymentData, ...requestData};

                if (action === "save") {
                    setLoadingSave(true);
                    dispatch(putClientPayment(postEditData, setLoadingSave, onSuccess));
                    dispatch(setSaveEditClientPayments(false));
                }
            } else if (templateType === "supplierPayments") {
                const validationResponse = validateSupplierPayment(SUPPLIERS_DATA.newSupplierPayment, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                let postSupplierPaymentData = {...SUPPLIERS_DATA.newSupplierPayment, ...requestData};
                if (action === "save") {
                    setLoadingSave(true);
                    postSupplierPaymentData.date = moment(postSupplierPaymentData.date).set({hour: Number(moment().format("HH")), minute: Number(moment().format("mm")), second: Number(moment().format("ss"))}).toDate();
                    dispatch(postSupplierPayment(postSupplierPaymentData, requestData, setLoadingSave, false, isEmronConnectFileERP, onSuccess));
                    dispatch(setSaveSupplierPayments(false));
                } else if (action === "saveandrepeat") {
                    setLoadingSave(true);
                    postSupplierPaymentData.date = moment(postSupplierPaymentData.date).set({hour: Number(moment().format("HH")), minute: Number(moment().format("mm")), second: Number(moment().format("ss"))}).toDate();
                    dispatch(postSupplierPayment(postSupplierPaymentData, requestData, setLoadingSave, true, isEmronConnectFileERP, onSuccess));
                    dispatch(setSaveSupplierPayments(false));
                }
            } else if (templateType === "editSupplierPayments") {
                const validationResponse = validateSupplierPayment(SUPPLIERS_DATA.editSupplierPayment, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                let postSupplierPaymentData = {...SUPPLIERS_DATA.editSupplierPayment, ...requestData};
                setLoadingSave(true);
                dispatch(putSupplierPayment(postSupplierPaymentData, setLoadingSave, onSuccess));
                dispatch(setSaveEditSupplierPayments(false));
            } else if (templateType === "newEmployee") {
                const employeeData = ACCOUNTING_DATA.newEmployee;
                const validation = validateEmployeeObject(employeeData);
                if (!validation.success) return toast.error(validation.message);

                let postEmployeeData = {...employeeData, ...requestData};
                if (ACTIVITY.sendEmployeeQROnSave) postEmployeeData.sendEmployeeQROnSave = true;

                setLoadingSave(true);
                dispatch(postEmployee(postEmployeeData, requestData, setLoadingSave, onSuccess));
            } else if (templateType === "primerAiUrl") { // Save new Primer Ai Url
                const validationResponse = validatePrimerAiUrlObject(SALES.newPrimerAiUrl);
                if (!validationResponse.success) return toast.error(validationResponse.message);

            } else if (templateType === "editEmployee") {
                const employeeData = ACCOUNTING_DATA.editEmployee;
                const validation = validateEditEmployeeObject(employeeData);

                if (!validation.success) return toast.error(validation.message);
                let postEditEmployeeData = {...employeeData, ...requestData};
                postEditEmployeeData.isActive = employeeData.isActive;

                if (ACTIVITY.sendEmployeeQROnSave) postEditEmployeeData.sendEmployeeQROnSave = true;
                if (ACTIVITY.sendEmployeeNewPasswordOnSave) postEditEmployeeData.sendEmployeeNewPasswordOnSave = true;
                if (ACTIVITY.sendEmployeeChangesToErgani) postEditEmployeeData.sendEmployeeChangesToErgani = true;
                dispatch(putEmployee(postEditEmployeeData, requestData, "update", setLoadingSave, onSuccess));
            } else if (templateType === "newAccountingAccount") {
                const accountData = ACCOUNTING_DATA.newAccountingAccount;
                const validation = validateAccountingAccountObject(accountData);

                if (!validation.success) return toast.error(validation.message);
                let postNewAccountingAccountData = {...accountData, ...requestData};
                setLoadingSave(true);
                dispatch(postAccountingAccount(postNewAccountingAccountData, requestData, setLoadingSave, onSuccess));
            } else if (templateType === "editAccountingAccount") {
                const accountData = ACCOUNTING_DATA.editAccountingAccount;
                const validation = validateEditAccountingAccountObject(accountData);

                if (!validation.success) return toast.error(validation.message);
                let postEditAccountingAccountData = {...accountData, ...requestData};
                dispatch(putAccountingAccount(postEditAccountingAccountData, requestData, setLoadingSave, onSuccess));
            } else if (templateType === "newAccountingRecord") {
                let postNewAccountingRecord = {...ACCOUNTING_DATA.newAccountingRecord, ...requestData};

                let date = new Date();
                if (date.getFullYear() === postNewAccountingRecord.date?.getFullYear() && date.getMonth() === postNewAccountingRecord.date?.getMonth() && date.getDate() === postNewAccountingRecord.date?.getDate()) {
                    postNewAccountingRecord.date = date;
                    postNewAccountingRecord.time = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
                }
                postNewAccountingRecord.accounts = postNewAccountingRecord.accounts.filter((el) => Number(el.credit) !== 0 || Number(el.debit) !== 0);

                const validationResponse = validateAccountingRecord(postNewAccountingRecord, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                if (isEmpty(postNewAccountingRecord.preNumber)) postNewAccountingRecord.preNumber = "noprefix";
                postNewAccountingRecord.date = moment(postNewAccountingRecord.date).set({hour: 12, minute: 0, second: 0}).toDate();
                dispatch(postAccountingRecord(postNewAccountingRecord, requestData, setLoadingSave, action, isEmronConnectFileERP, onSuccess));
            } else if (templateType === "editAccountingRecord") {
                let postNewAccountingRecord = {...ACCOUNTING_DATA.editAccountingRecord, ...requestData};
                postNewAccountingRecord.accounts = postNewAccountingRecord.accounts.filter((el) => Number(el.credit) !== 0 || Number(el.debit) !== 0);

                const validationResponse = validateAccountingRecord(postNewAccountingRecord, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                if(isEmpty(postNewAccountingRecord.preNumber)) postNewAccountingRecord.preNumber = "noprefix";
                postNewAccountingRecord.date = moment(postNewAccountingRecord.date).set({hour: 12, minute: 0, second: 0}).toDate();
                dispatch(putAccountingRecord(postNewAccountingRecord, requestData, setLoadingSave, onSuccess));
            } else if (templateType === "accountingClosure") {
                const closureData = ACCOUNTING_DATA.newAccountingClosure;
                const validation = validateAccountingClosureObject(closureData, company);

                if (!validation.success) return toast.error(validation.message);

                let postData = {...closureData, ...requestData};
                let dateNow = new Date();
                let selectedDate = new Date(postData.date);

                if (dateNow.getFullYear() === selectedDate.getFullYear() && dateNow.getMonth() === selectedDate.getMonth() && dateNow.getDate() === selectedDate.getDate()) {
                    postData.date = dateNow;
                    postData.time = dateNow.getHours() + ':' + String(dateNow.getMinutes()).padStart(2, '0');
                }
                dispatch(postAccountingClosure(postData, setLoadingSave, onSuccess));
            } else if (templateType === "newWorkMovement") {
                let postData = {...PAYROLL.newWorkMovement, ...requestData};
                const hours = String(postData.time).split(":")[0];
                const minutes = String(postData.time).split(":")[1];
                postData.date = moment(postData.date).set({hour: Number(hours), minute: Number(minutes), second: 0, millisecond: 0});
                dispatch(postWorkMovement(postData, setLoadingSave, onSuccess));
            } else if (templateType === "editWorkMovement") {
                // Cannot happen yet
            } else if (templateType === "newWorkPermit") {
                const workPermitData = PAYROLL.newWorkPermit;
                const validation = validateWorkPermitObject(workPermitData);
                if (!validation.success) {
                    dispatch(setSaveNewWorkPermit(true));
                    return toast.error(validation.message);
                }

                let postData = {...workPermitData, ...requestData};
                dispatch(setSaveNewWorkPermit(false));
                dispatch(postWorkPermit(postData, setLoadingSave, onSuccess));
            } else if (templateType === "editWorkPermit") {
                const editPermitData = PAYROLL.editWorkPermit;
                dispatch(setSaveEditWorkPermit(false));
                const validation = validateEditWorkPermitObject(editPermitData);

                if (!validation.success) {
                    dispatch(setSaveEditWorkPermit(true));
                    return toast.error(validation.message);
                }

                let postData = {...editPermitData, ...requestData};
                dispatch(putWorkPermit(postData, setLoadingSave, onSuccess));
            } else if (templateType === "newVisit") {
                const visitData = PRESCRIPTION.newVisit;
                dispatch(setSaveNewVisit(false));
                const validation = validateVisitObject(visitData);

                if (!validation.success) {
                    dispatch(setSaveNewVisit(true));
                    return toast.error(validation.message);
                }

                let postData = {...visitData, ...requestData, selectedClient: PRESCRIPTION.newVisitSelectedClient};
                dispatch(postNewVisit(postData, setLoadingSave, company, TABS_DATA, onSuccess));
            } else if (templateType === "activeVisit") {
                dispatch(setSaveActiveVisit(false));

                let postData = {...PRESCRIPTION.activeVisit, ...requestData};
                let validCheck = true;

                if (validCheck) {
                    const actionToPost = extraData ? extraData : action;
                    const loadingSetter = (bool) => {
                        if (loadingSave !== bool) setLoadingSave(bool);
                        if (loadingSaveAndRepeat !== bool) setLoadingSaveAndRepeat(bool);
                        if (loadingSaveActiveVisitInvoice !== bool) setLoadingSaveActiveVisitInvoice(bool);
                    }
                    dispatch(postActiveVisit(postData, loadingSetter, company, TABS_DATA, actionToPost, moreExtraData));
                } else {
                    dispatch(setSaveActiveVisit(true));
                }
            } else if (templateType === "fixedAssetsSettings") {
                dispatch(setSaveFixedAssetsSettings(false));
                const postData = {...FIXED_ASSETS.fixedAssetsSettings, ...requestData};
                dispatch(postFixedAssetsSettings(postData, setLoadingSave, onSuccess));
            } else if (templateType === "newFixedAsset") {
                const postData = {...FIXED_ASSETS.newFixedAsset, ...requestData};
                const validationResponse = validateFixedAsset(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(postFixedAsset(postData, SALES, BUYS, setLoadingSave, onSuccess));
            } else if (templateType === "editFixedAsset") {
                const postData = {...FIXED_ASSETS.editFixedAsset, ...requestData};
                const validationResponse = validateFixedAsset(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(updateFixedAsset(postData, SALES, BUYS, setLoadingSave, onSuccess));
            } else if (templateType === "newFixedAssetMovement") {
                dispatch(setSaveNewFixedAssetMovement(false));
                const postData = {...FIXED_ASSETS.newFixedAssetMovement, ...requestData};
                const validationResponse = validateFixedAssetMovement(postData, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(postFixedAssetMovement(postData, setLoadingSave, onSuccess));
            } else if (templateType === "editFixedAssetMovement") {
                dispatch(setSaveEditFixedAssetMovement(false));
                const postData = {...FIXED_ASSETS.editFixedAssetMovement, ...requestData};
                const validationResponse = validateFixedAssetMovement(postData, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(updateFixedAssetMovement(postData, setLoadingSave, onSuccess));
            } else if (templateType === "newFixedAssetRecord") {
                dispatch(setSaveNewFixedAssetRecord(false));
                const postData = {...FIXED_ASSETS.newFixedAssetRecord, ...requestData};
                const validationResponse = validateFixedAssetRecord(postData, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(postFixedAssetRecord(postData, onSuccess, setLoadingSave));
            } else if (templateType === "editFixedAssetRecord") {
                dispatch(setSaveEditFixedAssetRecord(false));
                const postData = {...FIXED_ASSETS.editFixedAssetRecord, ...requestData};
                const validationResponse = validateFixedAssetRecord(postData, company);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(updateFixedAssetRecord(postData, setLoadingSave, onSuccess));
            } else if (templateType === "cheques") {
                const cloneReq = quickClone(requestData);
                delete cloneReq.type;
                const postData = {...CASH_DATA.newCheque, ...cloneReq};
                const validationResponse = validateCheque(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(postCheque(postData, setLoadingSave));
            } else if (templateType === "editCheques") {
                const cloneReq = quickClone(requestData);
                delete cloneReq.type;
                const postData = {...CASH_DATA.editCheque, ...cloneReq};
                const validationResponse = validateCheque(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(updateCheque(postData, setLoadingSave));
            } else if (templateType === "newLoan") {
                const cloneReq = quickClone(requestData);
                delete cloneReq.type;
                const postData = {...CASH_DATA.newLoan, ...cloneReq};
                const validationResponse = validateLoan(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                postData.remainingPrincipal = postData.principal;

                dispatch(postLoan(postData, setLoadingSave));
            } else if (templateType === "editLoan") {
                const cloneReq = quickClone(requestData);
                delete cloneReq.type;
                const postData = {...CASH_DATA.editLoan, ...cloneReq};
                const validationResponse = validateLoan(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                postData.remainingPrincipal = +Number(postData.principal - postData.payments.reduce((sum, item) => sum + item.principalAmount, 0)).toFixed(2);

                dispatch(updateLoan(postData, setLoadingSave));
            } else if (templateType === "newCard") {
                const cloneReq = quickClone(requestData);
                delete cloneReq.type;
                delete cloneReq.isActive;
                const postData = {...CASH_DATA.newCard, ...cloneReq};
                const validationResponse = validateCard(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(postCard(postData, setLoadingSave));
            } else if (templateType === "editCard") {
                const cloneReq = quickClone(requestData);
                delete cloneReq.type;
                delete cloneReq.isActive;
                const postData = {...CASH_DATA.editCard, ...cloneReq};
                const validationResponse = validateCard(postData);
                if (!validationResponse.success) return toast.error(validationResponse.message);

                dispatch(updateCard(postData, setLoadingSave));
            }
        }
    }

    // Handle Print Layout Change
    const handePrintLayoutChange = (e) => {
        dispatch(setPrintLayout(e.value));
    }

    // Handle Send Email for Sales page on save
    const handleSendEmailOnSave = async (e) => {
        if (e.target && e.target.value) {
            if (e.target.value === "inactive") dispatch(setSendEmail(e.target.value));

            // Sales Send Mail on Save Option
            if (templateType === "sales" && e.target.value === "active") {
                let salesData = Object.assign({}, SALES);
                let tempSelectedRecipientEmails = [];
                let newSalesData = {sendEmail: e.target.value};
                if (salesData.newSales.client && salesData.newSales.client !== "") {
                    await axios.get(apiURL2 + `/client/get-client-id-by/${salesData.newSales.client}`)
                        .then((res) => {
                            if (res.data && res.data.status === "200") {
                                if (res.data.data.contactPoints.length > 0) {
                                    let contacts = [];
                                    res.data.data.contactPoints.map(contact => {
                                        if (contact.email && contact.email !== "") {
                                            contacts.push({
                                                label: (contact.name !== "" ? (contact.name + ",") : "") + (contact.mobile !== "" ? (contact.mobile + ",") : "") + (contact.landline !== "" ? (contact.landline + ",") : "") + contact.email,
                                                value: contact.email
                                            })
                                            if (contact.acceptsNotifications === "true") {
                                                setSelectedRecipientEmails([...tempSelectedRecipientEmails, contact.email])
                                                tempSelectedRecipientEmails.push(contact.email)
                                            }
                                        }
                                        return contact;
                                    })
                                    setRecipientEmails(contacts)
                                }
                                dispatch(setNewSales({...salesData.newSales, ...newSalesData}));
                            }
                        })
                    dispatch(setSendEmail(e.target.value));
                    scrollToEnd.current?.scrollIntoView({behavior: 'smooth', container: "nearest"})
                } else {
                    dispatch(setSendEmail(e.target.value));
                    dispatch(setSendEmail("inactive"));
                    toast.error("Please Select Client first!");
                }
            } else if (templateType === "quotations" && e.target.value === "active") {
                let salesData = Object.assign({}, SALES);
                let tempSelectedRecipientEmails = [];
                let newQuotationsData = {sendEmail: e.target.value};
                if (salesData.newQuotations.client && salesData.newQuotations.client !== "") {
                    await axios.get(apiURL2 + `/client/get-client-id-by/${salesData.newQuotations.client}`)
                        .then((res) => {
                            if (res.data && res.data.status === "200") {
                                if (res.data.data.contactPoints.length > 0) {
                                    let contacts = [];
                                    res.data.data.contactPoints.map(contact => {
                                        if (contact.email && contact.email !== "") {
                                            contacts.push({
                                                label: (contact.name !== "" ? (contact.name + ",") : "") + (contact.mobile !== "" ? (contact.mobile + ",") : "") + (contact.landline !== "" ? (contact.landline + ",") : "") + contact.email,
                                                value: contact.email
                                            })
                                            if (contact.acceptsNotifications === "true") {
                                                setSelectedRecipientEmails([...tempSelectedRecipientEmails, contact.email])
                                                tempSelectedRecipientEmails.push(contact.email)
                                            }
                                        }
                                        return contact;
                                    })
                                    setRecipientEmails(contacts)
                                }
                                dispatch(setNewQuotations({...salesData.newQuotations, ...newQuotationsData}));
                            }
                        })
                    dispatch(setSendEmail(e.target.value));
                    scrollToEnd.current?.scrollIntoView({behavior: 'smooth', container: "nearest"})
                } else {
                    dispatch(setSendEmail(e.target.value));
                    dispatch(setSendEmail("inactive"));
                    toast.error("Please Select Client first!");
                }
            } else if (templateType === "clientPayments" && e.target.value === "active") {
                let clients_data = Object.assign({}, CLIENTS_DATA)
                let tempSelectedRecipientEmails = [];
                let new_clients_data = {sendEmail: e.target.value}
                if (clients_data.newClientPayment.client && clients_data.newClientPayment.client !== "") {
                    await axios.get(apiURL2 + `/client/get-client-id-by/${clients_data.newClientPayment.client}`).then((res) => {
                        if (res.data && res.data.status === "200") {
                            if (res.data.data.contactPoints.length > 0) {
                                let contacts = [];
                                res.data.data.contactPoints.map(contact => {
                                    if (contact.email && contact.email !== "") {
                                        contacts.push({
                                            label: (contact.name !== "" ? (contact.name + ",") : "") + (contact.mobile !== "" ? (contact.mobile + ",") : "") + (contact.landline !== "" ? (contact.landline + ",") : "") + contact.email,
                                            value: contact.email
                                        })
                                        if (contact.acceptsNotifications === "true") {
                                            setSelectedRecipientEmails([...tempSelectedRecipientEmails, contact.email])
                                            tempSelectedRecipientEmails.push(contact.email)
                                        }
                                    }
                                    return contact;
                                })
                                setRecipientEmails(contacts)
                            }
                            dispatch(setNewClientPayment({...clients_data.newClientPayment, ...new_clients_data}));
                        }
                    })
                    dispatch(setSendEmail(e.target.value));
                    scrollToEnd.current?.scrollIntoView({behavior: 'smooth', container: "nearest"})
                } else {
                    dispatch(setSendEmail(e.target.value));
                    dispatch(setSendEmail("inactive"));
                    toast.error("Please Select Client first!");
                }
            } else if (templateType === "buys" && e.target.value === "active") {
                let buys = Object.assign({}, BUYS);
                let tempSelectedRecipientEmails = [];
                let new_buys = {sendEmail: e.target.value}
                if (buys.newBuys.supplier && buys.newBuys.supplier !== "") {
                    await axios.get(apiURL2 + `/supplier/get-supplier-id-by/${buys.newBuys.supplier}`).then((res) => {
                        if (res.data && res.data.status === "200") {
                            if (res.data.data.contactPoints.length > 0) {
                                let contacts = [];
                                res.data.data.contactPoints.map(contact => {
                                    if (contact.email && contact.email !== "") {
                                        contacts.push({
                                            label: (contact.name !== "" ? (contact.name + ",") : "") + (contact.mobile !== "" ? (contact.mobile + ",") : "") + (contact.landline !== "" ? (contact.landline + ",") : "") + contact.email,
                                            value: contact.email
                                        })
                                        if (contact.acceptsNotifications === "true") {
                                            setSelectedRecipientEmails([...tempSelectedRecipientEmails, contact.email])
                                            tempSelectedRecipientEmails.push(contact.email)
                                        }
                                    }
                                    return contact;
                                })
                                setRecipientEmails(contacts)
                            }
                            dispatch(setNewBuys({...buys.newBuys, ...new_buys}));
                        }
                    })
                    dispatch(setSendEmail(e.target.value));
                    scrollToEnd.current?.scrollIntoView({behavior: 'smooth', container: "nearest"})
                } else {
                    dispatch(setSendEmail(e.target.value));
                    dispatch(setSendEmail("inactive"));
                    toast.error("Please Select Client first!");
                }
            }
        }
    };

    useEffect(() => {
        const doFunc = async () => {
            if (templateType === "sales" && SALES.newSales.client !== "" && SALES.newSales.documentType !== "" && ACTIVITY?.sendEmail === "active") {
                dispatch(setSendEmail("inactive"));
                setSelectedRecipientEmails([]);
                let tempSelectedRecipientEmails = [];
                let salesData = Object.assign({}, SALES);
                await axios.get(apiURL2 + `/client/get-client-id-by/${SALES.newSales.client}`)
                    .then(async (res) => {
                        if (res.data && res.data.status === "200") {
                            if (res.data.data.contactPoints.length > 0) {
                                let contacts = [];
                                res.data.data.contactPoints.map(async contact => {
                                    if (contact.email && contact.email !== "") {
                                        contacts.push({
                                            label: (contact.name !== "" ? (contact.name + ",") : "") + (contact.mobile !== "" ? (contact.mobile + ",") : "") + (contact.landline !== "" ? (contact.landline + ",") : "") + contact.email,
                                            value: contact.email
                                        })
                                        if (contact.acceptsNotifications === "true") {
                                            setSelectedRecipientEmails([...tempSelectedRecipientEmails, contact.email])
                                            tempSelectedRecipientEmails.push(contact.email)
                                        }
                                    }
                                    return contact;
                                })
                                setRecipientEmails(contacts)
                                let newSalesData = {sendEmail: "true"};
                                dispatch(setNewSales({...salesData.newSales, ...newSalesData}));
                            }
                        }
                    })
                dispatch(setSendEmail("active"));
            }
            if (templateType === "sales" && SALES.newSales.documentType !== "" && SALES.newSales.client === "") {
                const advDoc = SETTINGS.settings.advancedTypesSales.filter((doc) => doc._id === SALES.newSales.documentType);
                if (advDoc.length > 0) {
                    if (advDoc[0].sendEmailAfterSave === "active") {
                        dispatch(setSendEmail("active"));
                    } else {
                        setSelectedRecipientEmails([]);
                        dispatch(setSendEmail("inactive"));
                    }
                }

                // Sales Send Mail on Save Option
                if (templateType === "buys") {
                    let buysData = Object.assign({}, BUYS);
                    dispatch(setNewBuys(buysData.newBuys));
                }
            }
            if (templateType === "quotations" && SALES.newQuotations.client !== "" && SALES.newQuotations.documentType !== "" && ACTIVITY?.sendEmail === "active") {
                dispatch(setSendEmail("inactive"));
                setSelectedRecipientEmails([]);
                let tempSelectedRecipientEmails = [];
                let salesData = Object.assign({}, SALES);
                await axios.get(apiURL2 + `/client/get-client-id-by/${SALES.newQuotations.client}`)
                    .then(async (res) => {
                        if (res.data && res.data.status === "200") {
                            if (res.data.data.contactPoints.length > 0) {
                                let contacts = [];
                                res.data.data.contactPoints.map(async contact => {
                                    if (contact.email && contact.email !== "") {
                                        contacts.push({
                                            label: (contact.name !== "" ? (contact.name + ",") : "") + (contact.mobile !== "" ? (contact.mobile + ",") : "") + (contact.landline !== "" ? (contact.landline + ",") : "") + contact.email,
                                            value: contact.email
                                        })
                                        if (contact.acceptsNotifications === "true") {
                                            setSelectedRecipientEmails([...tempSelectedRecipientEmails, contact.email])
                                            tempSelectedRecipientEmails.push(contact.email)
                                        }
                                    }
                                    return contact;
                                })
                                setRecipientEmails(contacts)
                                let newQuotationsData = {sendEmail: "true"};
                                dispatch(setNewQuotations({...salesData.newQuotations, ...newQuotationsData}));
                            }
                        }
                    })
                dispatch(setSendEmail("active"));
            }
            if (templateType === "quotations" && SALES.newQuotations.documentType !== "" && SALES.newQuotations.client === "") {
                const advDoc = SETTINGS.settings.advancedTypes.filter((doc) => doc._id === SALES.newQuotations.documentType);
                if (advDoc.length > 0) {
                    if (advDoc[0].sendEmailAfterSave === "active") {
                        dispatch(setSendEmail("active"));
                    } else {
                        setSelectedRecipientEmails([]);
                        dispatch(setSendEmail("inactive"));
                    }
                }
            }
            if (templateType === "clientPayments" && CLIENTS_DATA.newClientPayment.documentType !== "") {
                const advDoc = SETTINGS.settings.advancedTypes.filter((doc) => doc._id === CLIENTS_DATA.newClientPayment.documentType);
                if (advDoc.length > 0) {
                    if (advDoc[0].sendEmailAfterSave === "active") {
                        dispatch(setSendEmail("active"));
                    } else {
                        setSelectedRecipientEmails([]);
                        dispatch(setSendEmail("inactive"));
                    }
                }
            }
            if (templateType === "buys" && BUYS.newBuys.documentType !== "") {
                const advDoc = SETTINGS.settings.advancedTypes.filter((doc) => doc._id === BUYS.newBuys.documentType);
                if (advDoc.length > 0) {
                    if (advDoc[0].sendEmailAfterSave === "active") {
                        dispatch(setSendEmail("active"));
                    } else {
                        setSelectedRecipientEmails([]);
                        dispatch(setSendEmail("inactive"));
                    }
                }
            }
        }
        doFunc();
    }, [SALES.newSales.client, SALES.newSales.documentType, SALES.editSales[tabKey]?.client, CLIENTS_DATA.newClientPayment.documentType, BUYS.newBuys])

    const handleOnEmailChange = (e, type = "default") => {
        let value = '';
        if (type === 'msdd') {
            value = getMultiSelectOptionsToArray(e);
            setSelectedRecipientEmails(value);
            if (value.length > 0) {
                // setSendButton(true);
            }
        } else if (type === 'dd') {
            value = e.target.value.split(',');
            let customEmails = [];
            value.map(email => {
                const emailValid = validateEmail(email);
                if (emailValid) {
                    setEmailError(false);
                    customEmails.push(email);
                } else if (email.length === 0) {
                    setEmailError(false);
                } else {
                    setEmailError(true);
                }
                return email;
            })
            setSelectedCustomRecipientEmails(customEmails);
        }
    }

    const handleOnChange = async (e, type = "default", ddname = "") => {
        let value = '';
        let name = '';

        if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else if (type === 'ac') {
            name = ddname;
            value = e.row.value;
        } else if (type === 'dp') {
            value = e;
        } else if (type === "checkbox") {
            value = e.target.checked;
        } else if (type === "bettercheckbox") {
            value = e.target.checked ? "active" : "inactive";
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        if (name === "documentType") {
            setConvertQuotationToType(value);
        }
    }

    const handleSaveActivePriceList = () => {
        if (templateType === "editPriceList") {
            let postPriceListData = {...requestData, ...PRODUCTS_DATA.editPriceList};
            postPriceListData.updateAnyway = "true";
            let haveProducts = false;
            let haveName = false;
            if (postPriceListData.name && postPriceListData?.name !== "") {
                haveName = true;
            } else {
                toast.error("Name is required field.");
            }
            if (postPriceListData.productList && postPriceListData?.productList?.length > 0) {
                haveProducts = true;
            } else {
                toast.error("Please check all mandatory fields.");
            }
            if (haveProducts && haveName) {
                dispatch(putPriceList(postPriceListData, requestData, "update", setLoadingSave, setActivePriceListModal, onSuccess)); // Put Price List To API
            }
        } else {
            let postPriceListData = {...requestData, ...PRODUCTS_DATA.newPriceList};
            postPriceListData.updateAnyway = "true";
            let haveProducts = false;
            let haveName = false;
            if (postPriceListData.name && postPriceListData?.name !== "") {
                haveName = true;
            } else {
                toast.error("Name is required field.");
            }
            if (postPriceListData.productList && postPriceListData?.productList?.length > 0) {
                haveProducts = true;
            } else {
                toast.error("Please check all mandatory fields.");
            }
            if (haveProducts && haveName) {
                if (postPriceListData._id) {
                    dispatch(putPriceList(postPriceListData, requestData, "update", setLoadingSave, setActivePriceListModal, onSuccess)); // Post Price List To API
                } else {
                    dispatch(postPriceList(postPriceListData, requestData, true, setLoadingSave, setActivePriceListModal, onSuccess)); // Post Price List To API
                }
            }
        }
    }

    const handleDelete = () => {
        //console.log(TABS_DATA);
        //console.log(templateType);
        showDeletionModal(true);
        if (templateType === "editProduct") {
            setToBeDeleted(PRODUCTS_DATA.selectedEditProduct[tabKey]._id);
            setDeleteModalTableName("Search Products");
        } else if (templateType === "editClientPayments") {
            setToBeDeleted(CLIENTS_DATA.editClientPayment._id);
            setDeleteModalTableName("Client Payments Search");
        } else if (templateType === "editProductMovements") {
            setToBeDeleted(PRODUCTS_DATA.editProductMovements._id);
            setDeleteModalTableName("Search Product Movements");
        } else if (templateType === "editPriceList") {
            setToBeDeleted(PRODUCTS_DATA.editPriceList._id);
            setDeleteModalTableName("Search Product Price List");
        } else if (templateType === "editClient") {
            setToBeDeleted(CLIENTS_DATA.editClient[tabKey]._id);
            setDeleteModalTableName("Client Search");
        } else if (templateType === "editClientMovements") {
            setToBeDeleted(CLIENTS_DATA.editClientMovements._id);
            setDeleteModalTableName("Client Movements Search");
        } else if (templateType === "editSupplier") {
            setToBeDeleted(SUPPLIERS_DATA.editSupplier[tabKey]._id);
            setDeleteModalTableName("Supplier Search");
        } else if (templateType === "editSupplierMovements") {
            setToBeDeleted(SUPPLIERS_DATA.editSupplierMovements._id);
            setDeleteModalTableName("Supplier Movements Search");
        } else if (templateType === "editSupplierPayments") {
            setToBeDeleted(SUPPLIERS_DATA.editSupplierPayment._id);
            setDeleteModalTableName("Supplier Payments Search");
        } else if (templateType === "editCashRegisters") {
            setToBeDeleted(CASH_DATA.editCashRegisters._id);
            setDeleteModalTableName("Cash Registers Search");
        } else if (templateType === "editPOS") {
            setToBeDeleted(CASH_DATA.editPOS._id);
            setDeleteModalTableName("POS Search");
        } else if (templateType === "editBankAccounts") {
            setToBeDeleted(CASH_DATA.editBankAccount._id);
            setDeleteModalTableName("Bank Account Search");
        } else if (templateType === "editBasicType") {
            setToBeDeleted(SETTINGS.settings.editBasicType._id);
            setDeleteModalTableName("Basic Types Search");
        } else if (templateType === "editAdvancedType") {
            setToBeDeleted(SETTINGS.settings.editAdvancedType._id);
            setDeleteModalTableName("Advanced Types Search");
        } else if (templateType === "editSales") {
            setToBeDeleted(SALES.editSales[tabKey]._id);
            setDeleteModalTableName("Sales Search");
        } else if (templateType === "editQuotations") {
            setToBeDeleted(SALES.editQuotations[tabKey]._id);
            setDeleteModalTableName("Quotations Search");
        } else if (templateType === "editAccountingRecord") {
            setToBeDeleted(ACCOUNTING_DATA.editAccountingRecord._id);
            setDeleteModalTableName("Accounting Record Search");
        } else if (templateType === "editWorkPermit") {
            setToBeDeleted(PAYROLL.editWorkPermit._id);
            setDeleteModalTableName("Work Permits Search");
        } else if (templateType === "editFixedAsset") {
            setToBeDeleted(FIXED_ASSETS.editFixedAsset._id);
            setDeleteModalTableName("Fixed Assets Search");
        } else if (templateType === "editFixedAssetRecord") {
            setToBeDeleted(FIXED_ASSETS.editFixedAssetRecord._id);
            setDeleteModalTableName("Fixed Asset Records Search");
        } else if (templateType === "editFixedAssetMovement") {
            setToBeDeleted(FIXED_ASSETS.editFixedAssetMovement._id);
            setDeleteModalTableName("Fixed Asset Movements Search");
        } else if (templateType === "editBuys") {
            setToBeDeleted(BUYS.editBuys._id);
            setDeleteModalTableName("Buys Search");
        } else if (templateType === "editCheques") {
            setToBeDeleted(CASH_DATA.editCheque._id);
            setDeleteModalTableName("Cheques Search");
        } else if (templateType === "editLoan") {
            setToBeDeleted(CASH_DATA.editLoan._id);
            setDeleteModalTableName("Loans Search");
        } else if (templateType === "editCard") {
            setToBeDeleted(CASH_DATA.editCard._id);
            setDeleteModalTableName("Cards Search");
        }
    }

    const showDeletionModal = (bool) => {
        if (bool === false) {
            setToBeDeleted("");
            setDeleteModalTableName("");
        }
        setShowDeleteModal(bool);
    }

    const handleAfterDelete = () => {
        if (templateType === "editProduct") {
            dispatch(addToForceRefresh("Search Products"));
            dispatch(removeTab("edit-product"));
        } else if (templateType === "editClientPayments") {
            dispatch(addToForceRefresh("Client Payments Search"));
            dispatch(removeTab("edit-client-payments"));
        } else if (templateType === "editProductMovements") {
            dispatch(addToForceRefresh("Search Product Movements"));
            dispatch(removeTab("edit-product-movements"));
        } else if (templateType === "editPriceList") {
            dispatch(addToForceRefresh("Search Product Price List"));
            dispatch(removeTab("edit-price-list"));
        } else if (templateType === "editClient") {
            dispatch(addToForceRefresh("Client Search"));
            dispatch(removeTab("edit-client"));
        } else if (templateType === "editClientMovements") {
            dispatch(addToForceRefresh("Client Movements Search"));
            dispatch(removeTab("edit-client-movements"));
        } else if (templateType === "editSupplier") {
            dispatch(addToForceRefresh("Supplier Search"));
            dispatch(removeTab("edit-supplier"));
        } else if (templateType === "editSupplierMovements") {
            dispatch(addToForceRefresh("Supplier Movements Search"));
            dispatch(removeTab("edit-supplier-movements"));
        } else if (templateType === "editSupplierPayments") {
            dispatch(addToForceRefresh("Supplier Payments Search"));
            dispatch(removeTab("edit-supplier-payments"));
        } else if (templateType === "editCashRegisters") {
            dispatch(addToForceRefresh("Cash Registers Search"));
            dispatch(removeTab("edit-cash-registers"));
        } else if (templateType === "editPOS") {
            dispatch(addToForceRefresh("POS Search"));
            dispatch(removeTab("edit-pos"));
        } else if (templateType === "editBankAccounts") {
            dispatch(addToForceRefresh("Bank Account Search"));
            dispatch(removeTab("edit-bank-account"));
        } else if (templateType === "editBasicType") {
            dispatch(addToForceRefresh("Basic Types Search"));
            dispatch(removeTab("edit-basic-types"));
        } else if (templateType === "editAdvancedType") {
            dispatch(addToForceRefresh("Advanced Types Search"));
            dispatch(removeTab("edit-advanced-types"));
        } else if (templateType === "editSales") {
            dispatch(addToForceRefresh("Sales Search"));
            dispatch(removeTab("view-sales"));
        } else if (templateType === "editQuotations") {
            dispatch(addToForceRefresh("Quotations Search"));
            dispatch(removeTab("sales-quotations-edit"));
        } else if (templateType === "editAccountingRecord") {
            dispatch(addToForceRefresh("Accounting Record Search"));
            dispatch(removeTab("accounting-record-edit"));
        } else if (templateType === "editWorkPermit") {
            dispatch(addToForceRefresh("Work Permits Search"));
            dispatch(removeTab("edit-work-permit"));
        } else if (templateType === "editBuys") {
            dispatch(addToForceRefresh("Buys Search"));
            dispatch(removeTab("edit-buys"));
        } else if (templateType === "editFixedAssetRecord") {
            dispatch(addToForceRefresh("Fixed Asset Records"));
            dispatch(removeTab("edit-fixed-asset-record"));
        } else if (templateType === "editFixedAssetMovement") {
            dispatch(addToForceRefresh("Fixed Asset Movements"));
            dispatch(removeTab("edit-fixed-asset-movement"));
        } else if (templateType === "editCheques") {
            dispatch(addToForceRefresh("Cheques Search"));
            dispatch(removeTab("edit-cheque"));
        } else if (templateType === "editLoan") {
            dispatch(addToForceRefresh("Loans Search"));
            dispatch(removeTab("edit-loan"));
        } else if (templateType === "editCard") {
            dispatch(addToForceRefresh("Cards Search"));
            dispatch(removeTab("cards-edit"));
        }
    }

    // Convert Quotation Confirmation
    const handleConvertQuotationConfirm = (quotationObject) => {
        setDisableConvertOkBtn(true);
        if (quotationObject && convertQuotationToType) {
            const targetDocSettings = SETTINGS.settings.advancedTypesSales.find(
                (doc) => String(doc._id) === String(convertQuotationToType)
            );
            if (!targetDocSettings) {
                toast.error("Could not find settings for the selected document type.");
                setDisableConvertOkBtn(false);
                return;
            }
            const myDataType = targetDocSettings.myDataType;
            const productIds = quotationObject.products.map(product => product._id);
            let data = {
                myDataType: myDataType,
                products: productIds,
            };
            axios.post(apiURL2 + `/sale/check-products-characterization`, JSON.stringify(data), {
                headers: {"Content-Type": "application/json"},
            }).then((res) => {
                setDisableConvertOkBtn(false);
                if (res.data && res.data.status === "200") {
                    const corSaleData = {
                        targetDocumentType: convertQuotationToType,
                        sourceSale: quotationObject,
                        sourceType: "quotation",
                    };
                    dispatch(setCorrelatedSaleData(corSaleData));
                    dispatch(openNewSale(TABS_DATA));
                    setShowConvertQuotationConfirmation(false);
                } else {
                    toast.error(res.data.message);
                }
            }).catch((error) => {
                setDisableConvertOkBtn(false);
                if (error && error.response && error.response.data && error.response.data.errors) {
                    toast.error(error.response.data.errors);
                } else {
                    console.log(error);
                }
            });
        } else {
            toast.error("Please select a document type.");
            setDisableConvertOkBtn(false);
        }
    }

    // Convert Document Confirmation
    const handleConvertDocumentConfirm = (saleObject) => {
        setDisableConvertOkBtn(true);
        if (saleObject) {
            const foundDocumentType = SETTINGS.settings.advancedTypesSales.find((doc) => String(saleObject.documentType) === String(doc._id));
            const foundConversionDoc = SETTINGS.settings.advancedTypesSales.find((doc) => String(foundDocumentType.conversionDocument) === String(doc._id));
            const myDataType = foundConversionDoc.myDataType;
            const productIds = saleObject.products.map(product => product._id);
            let data = {
                myDataType: myDataType,
                products: productIds,
            };
            axios.post(apiURL2 + `/sale/check-products-characterization`, JSON.stringify(data), {
                headers: {"Content-Type": "application/json"},
            }).then((res) => {
                setDisableConvertOkBtn(false);
                if (res.data && res.data.status === "200") {
                    const corSaleData = {
                        targetDocumentType: foundDocumentType.conversionDocument,
                        sourceSale: saleObject
                    };
                    dispatch(setCorrelatedSaleData(corSaleData));
                    dispatch(openNewSale(TABS_DATA));
                } else {
                    toast.error(res.data.message);
                }
            }).catch((error) => {
                setDisableConvertOkBtn(false);
                if (error && error.response && error.response.data && error.response.data.errors) {
                    toast.error(error.response.data.errors);
                }
            });
        } else {
            toast.success("Sales id not found.");
            setDisableConvertOkBtn(false);
        }
    };

    // Issue Credit Document Confirmation
    const handleIssueCreditDocumentConfirm = (salesId, setButton) => {
        setDisableIssueCreditOkBtn(true);
        if (salesId) {
            let data = { salesDocumentId: salesId }
            setButton(true);
            axios.post(apiURL2 + `/sale/issue-credit-document`, JSON.stringify(data), {
                headers: {"Content-Type": "application/json"},
            }).then((res) => {
                setButton(false);
                if (res.data && res.data.status === "200") {
                    toast.success(res.data.message);
                    setEnableIssueCDBtn(false);
                } else if (res.data && res.data?.error === "400") {
                    toast.error(res.data.message);
                } else if (res.data && res.data?.error === "409") {
                    setEnableIssueCDBtn(false);
                    toast.error(res.data.message);
                } else {
                    toast.error(res.data?.message);
                }

                setShowIssueCreditDocumentConfirmation(false);
            }).catch((error) => {
                setButton(false);
                if (error && error.response && error.response.data && error.response.data.errors) {
                    toast.error(error.response.data.errors);
                    setDisableIssueCreditOkBtn(true);
                }
            });
        } else {
            toast.success("Sales id not found.");
            setDisableIssueCreditOkBtn(true);
        }
    }

    // Handle Delete Template
    const handleDeleteTemplate = (e, key, row) => {
        const deleteRequest = {
            id: row.value,
            name: row.label,
            isActive: "delete",
            company: company.id,
            year: company.year.toString(),
            type: templateType,
        }
        dispatch(putTemplate(deleteRequest, requestData, "delete"));

        if (defaultTemplate?.label === row?.label) {
            setDefaultTemplate(null);
        }
    }

    const templateColumns = [{
        label: t('SaveAsTemplateIndex.placeholder'), name: "label",
    }]

    let showPrintBtn = false;
    // Enable or Disable Save / Save Repeat Button

    let actionsDisabled = !ACTIVITY.editing;

    if (templateType === "product") {
        actionsDisabled = !ACTIVITY.saveNewProduct;
    } else if (templateType === "editProduct") {
        actionsDisabled = !ACTIVITY.saveEditProduct;
    } else if (templateType === "sales") {
        actionsDisabled = !ACTIVITY.saveSales;
        showPrintBtn = isValidSalesData(SALES.newSales);
        if (ACTIVITY?.sendEmail === "active" && ((selectedRecipientEmails.length === 0 && selectedCustomRecipientEmails.length === 0) || emailError === true)) {
            actionsDisabled = true;
        }
    } else if (templateType === "quotations") {
        actionsDisabled = !ACTIVITY.saveQuotations;
        showPrintBtn = isValidQuotationsData(SALES.newQuotations);
        printLayoutOptions = quotationsPrintTemplates();
        if (ACTIVITY?.sendEmail === "active" && ((selectedRecipientEmails.length === 0 && selectedCustomRecipientEmails.length === 0) || emailError === true)) {
            actionsDisabled = true;
        }
    } else if (templateType === "buys") {
        actionsDisabled = !ACTIVITY.saveBuys;
        showPrintBtn = isValidBuysData(BUYS.newBuys);
        printLayoutOptions = buysPrintTemplates();
        if (!["3.1", "3.2", "10.1", "10.2"].includes(BUYS.newBuys?.myDataType)) {
            printLayoutDropdown = false;
            printBtn = false;
            sendEmailOnSave = false;
            if (ACTIVITY?.sendEmail) dispatch(setSendEmail(false));
        }
    } else if (templateType === "client") {
        actionsDisabled = !ACTIVITY.saveNewClient;
    } else if (templateType === "editClient") {
        actionsDisabled = !ACTIVITY.saveEditClient;
    } else if (templateType === "supplier") {
        actionsDisabled = !ACTIVITY.saveNewSupplier;
    } else if (templateType === "editSupplier") {
        actionsDisabled = !ACTIVITY.saveEditSupplier;
    } else if (templateType === "editSales") {
        actionsDisabled = !ACTIVITY.saveEditSales;
        showPrintBtn = isValidSalesData(SALES.editSales[tabKey]);
    } else if (templateType === "editQuotations") {
        actionsDisabled = !ACTIVITY.saveEditQuotations;
        showPrintBtn = SALES.editQuotations[tabKey] ? isValidQuotationsData(SALES.editQuotations[tabKey]) : false;
        printLayoutOptions = quotationsPrintTemplates();
        if (ACTIVITY?.sendEmail === "active" && (emailError === true)) {
            actionsDisabled = true;
        }
    } else if (templateType === "editBuys") {
        actionsDisabled = !ACTIVITY.saveEditBuys;
        showPrintBtn = isValidBuysData(BUYS.editBuys);
        printLayoutOptions = buysPrintTemplates();
        if (!["3.1", "3.2", "10.1", "10.2"].includes(BUYS.editBuys?.myDataType)) {
            printLayoutDropdown = false;
            printBtn = false;
            if (ACTIVITY?.sendEmail) dispatch(setSendEmail(false));
        }
    } else if (templateType === "productMovements") {
        actionsDisabled = !ACTIVITY.saveNewProductMovements;
    } else if (templateType === "editProductMovements") {
        actionsDisabled = !ACTIVITY.saveEditProductMovements;
    } else if (templateType === "priceList") {
        actionsDisabled = !ACTIVITY.saveNewPriceList;
    } else if (templateType === "editPriceList") {
        actionsDisabled = !ACTIVITY.saveEditPriceList;
    } else if (templateType === "cashRegisters") {
        actionsDisabled = !ACTIVITY.saveNewCashRegister;
    } else if (templateType === "POS") {
        actionsDisabled = !ACTIVITY.saveNewPOS;
    } else if (templateType === "bankAccounts") {
        actionsDisabled = !ACTIVITY.saveNewBankAccounts;
    } else if (templateType === "editCashRegisters") {
        actionsDisabled = !ACTIVITY.saveEditCashRegister;
    } else if (templateType === "editPOS") {
        actionsDisabled = !ACTIVITY.saveEditPOS;
    } else if (templateType === "editBankAccounts") {
        actionsDisabled = !ACTIVITY.saveEditBankAccounts;
    } else if (templateType === "salesGeneralSettings") {
        actionsDisabled = !ACTIVITY.saveSalesSettings;
    } else if (templateType === "buysGeneralSettings") {
        actionsDisabled = !ACTIVITY.saveBuysSettings;
    } else if (templateType === "basicType") {
        actionsDisabled = !ACTIVITY.saveBasicType;
    } else if (templateType === "editBasicType") {
        actionsDisabled = !ACTIVITY.saveEditBasicType;
    } else if (templateType === "advancedType") {
        actionsDisabled = !ACTIVITY.saveAdvancedType;
    } else if (templateType === "editAdvancedType") {
        actionsDisabled = !ACTIVITY.saveEditAdvancedType;
    } else if (templateType === "clientPayments") {
        actionsDisabled = !ACTIVITY.saveClientPayments;
        printLayoutOptions = clientPaymentsPrintTemplates();
    } else if (templateType === "supplierPayments") {
        actionsDisabled = !ACTIVITY.saveSupplierPayments;
    } else if (templateType === "editClientPayments") {
        actionsDisabled = !ACTIVITY.saveEditClientPayments;
        showPrintBtn = true
        printLayoutOptions = clientPaymentsPrintTemplates();
    } else if (templateType === "editSupplierPayments") {
        actionsDisabled = !ACTIVITY.saveEditSupplierPayments;
    } else if (templateType === "settingsPrimeData") {
        actionsDisabled = !ACTIVITY.savePrimerMyDataData;
    } else if (templateType === "settingsEmailSmtp") {
        actionsDisabled = !ACTIVITY.saveEmailSMtp;
    } else if (templateType === "newEmployee") {
        actionsDisabled = !ACTIVITY.saveNewEmployee;
    } else if (templateType === "newAccountingRecord") {
        actionsDisabled = !ACTIVITY.saveNewAccountingRecord;
    } else if (templateType === "editAccountingRecord") {
        actionsDisabled = !ACTIVITY.saveEditAccountingRecord;
    } else if (templateType === "editEmployee") {
        actionsDisabled = !ACTIVITY.saveEditEmployee;
    } else if (templateType === "newAccountingAccount") {
        actionsDisabled = !ACTIVITY.saveNewAccountingAccount;
    } else if (templateType === "editAccountingAccount") {
        actionsDisabled = !ACTIVITY.saveEditAccountingAccount;
    } else if (templateType === "cashAccountingSettings") {
        actionsDisabled = !ACTIVITY.saveCashAccountingSettings;
    } else if (templateType === "newWorkMovement") {
        actionsDisabled = !ACTIVITY.saveNewWorkMovement;
    } else if (templateType === "editWorkMovement") {
        actionsDisabled = true;
    } else if (templateType === "newWorkPermit") {
        actionsDisabled = !ACTIVITY.saveNewWorkPermit;
    } else if (templateType === "editWorkPermit") {
        actionsDisabled = !ACTIVITY.saveEditWorkPermit;
    } else if (templateType === "accountingClosure") {
        actionsDisabled = !ACTIVITY.saveNewAccountingClosure;
    } else if (templateType === "newVisit") {
        actionsDisabled = !ACTIVITY.saveNewVisit;
    } else if (templateType === "activeVisit") {
        actionsDisabled = !ACTIVITY.saveActiveVisit;
    } else if (templateType === "fixedAssetsSettings") {
        actionsDisabled = !ACTIVITY.saveFixedAssetsSettings;
    } else if (templateType === "newFixedAsset") {
        actionsDisabled = !ACTIVITY.saveNewFixedAsset;
    } else if (templateType === "editFixedAsset") {
        actionsDisabled = !ACTIVITY.saveEditFixedAsset;
    } else if (templateType === "newFixedAssetMovement") {
        actionsDisabled = !ACTIVITY.saveNewFixedAssetMovement;
    } else if (templateType === "editFixedAssetMovement") {
        actionsDisabled = !ACTIVITY.saveEditFixedAssetMovement;
    } else if (templateType === "newFixedAssetRecord") {
        actionsDisabled = !ACTIVITY.saveNewFixedAssetRecord;
    } else if (templateType === "editFixedAssetRecord") {
        actionsDisabled = !ACTIVITY.saveEditFixedAssetRecord;
    } else if (templateType === "cheques") {
        actionsDisabled = !ACTIVITY.saveNewCheque;
    } else if (templateType === "editCheques") {
        actionsDisabled = false;
    } else if (templateType === "newLoan") {
        actionsDisabled = !ACTIVITY.saveNewLoan;
    } else if (templateType === "editLoan") {
        actionsDisabled = false;
    } else if (templateType === "newCard") {
        actionsDisabled = !ACTIVITY.saveNewCard;
    } else if (templateType === "editCard") {
        actionsDisabled = false;
    }

    useEffect(() => {
        if (printLayoutOptions.filter((el) => el.value === SALES.printLayout).length === 0) {
            dispatch(setPrintLayout(''));
        }
    }, [printLayoutOptions])

    // template type → permission prefix for save and delete buttons plus edit functionality
    const permissionsMappingSave = {
        "product": "products-products/new",
        "editProduct" : "products-products/edit",
        "productMovements": "products-productsmovements/new",
        "editProductMovements": "products-productsmovements/edit",
        "priceList": "products-pricelist/new",
        "editPriceList": "products-pricelist/edit",
        "sales": "sales-sales/new",
        "quotations": "sales-quotations/new",
        "editQuotations": "sales-quotations/edit",
        "primerAiUrl": "sales-primeraiurl/new",
        "clientPayments": "sales-clientpayments/new",
        "editClientPayments": "sales-clientpayments/edit",
        "buys": "buys-buy/new",
        "editBuys": "buys-buy/edit",
        "supplierPayments": "buys-supplierpayments/new",
        "editSupplierPayments": "buys-supplierpayments/edit",
        "client": "clients-clients/new",
        "editClient": "clients-clients/edit",
        "clientMovements": "clients-clientmovements/new",
        "editClientMovements": "clients-clientmovements/edit",
        "supplier": "suppliers-suppliers/new",
        "editSupplier": "suppliers-suppliers/edit",
        "supplierMovements": "suppliers-suppliermovements/new",
        "editSupplierMovements": "suppliers-suppliermovements/edit",
        "cashRegisters": "cash-cashregisters/new",
        "editCashRegisters": "cash-cashregisters/edit",
        "POS": "cash-pos/new",
        "editPOS": "cash-pos/edit",
        "cheques": "cash-cheques/new",
        "editCheques": "cash-cheques/edit",
        "newLoan": "cash-loans/new",
        "editLoan": "cash-loans/edit",
        "newCard": "cash-cards/new",
        "editCard": "cash-cards/edit",
        "bankAccounts": "cash-bankaccounts/new",
        "editBankAccounts": "cash-bankaccounts/edit",
        "salesGeneralSettings": "sales-settings/salesgeneralsettings",
        "buysGeneralSettings": "buys-settings/buygeneralsettings",
        "clientsSettings": "clients-settings/clientsettings",
        "suppliersSettings": "suppliers-settings/suppliersettings",
        "basicType": "settings-documenttype/basictypesnew",
        "editBasicType": "settings-documenttype/basictypesedit",
        "advancedType": "settings-documenttype/advancedtypesnew",
        "editAdvancedType": "settings-documenttype/advancedtypesedit",
        "settingsPrimeData": "settings-primermydata/data",
        "settingsEmailSmtp": "settings-generalsettings/emailsmtp",
        "newAccountingAccount": "accounting-accountingaccounts/new",
        "editAccountingAccount": "accounting-accountingaccounts/edit",
        "newAccountingRecord": "accounting-accountingrecords/new",
        "editAccountingRecord": "accounting-accountingrecords/edit",
        "newWorkMovement": "payroll-workmovements/new",
        "editWorkMovement": "payroll-workmovements/edit",
        "newWorkPermit": "payroll-workpermits/new",
        "editWorkPermit": "payroll-workpermits/edit",
        "newFixedAsset": "fixedassets-fixedassets/new",
        "editFixedAsset": "fixedassets-fixedassets/edit",
        "newFixedAssetMovement": "fixedassets-movements/new",
        "editFixedAssetMovement": "fixedassets-movements/edit",
        "newFixedAssetRecord": "fixedassets-records/new",
        "editFixedAssetRecord": "fixedassets-records/edit",

        "newEmployee": ["accounting-employees/new", "payroll-employees/new"],
        "editEmployee": ["accounting-employees/edit", "payroll-employees/edit"],
    }

    const hasSavePermission = () => {
        const perm = permissionsMappingSave[templateType];
        if (perm) {
            if (typeof perm === "string") {
                return checkPermission(perm + "-write", permissionsData);
            } else if (typeof perm === "object") {
                return perm.some((el) => checkPermission(el + "-write", permissionsData));
            }
        } else {
            return true;
        }
    }

    const hasDeletePermission = () => {
        const perm = permissionsMappingSave[templateType];
        if (perm) {
            if (typeof perm === "string") {
                return checkPermission(perm + "-delete", permissionsData);
            } else if (typeof perm === "object") {
                return perm.some((el) => checkPermission(el + "-delete", permissionsData));
            }
        } else {
            return true;
        }
    }

    const handlePaymentReturn = () => {
        if (CLIENTS_DATA.editClientPayment.myDataType === "8.4") {
            setShowPaymentReturnModal(false);
            setShowPOSModalCancel(true);
        }
        axios.post(process.env.REACT_APP_API_URL2 + "/client/return-client-payment", {company: company.id, cpId: CLIENTS_DATA.editClientPayment._id}, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            setShowPaymentReturnModal(false);
            setShowPOSModalCancel(false);
            if (res.data.status === "200") {
                toast.success(res.data.message);
                setPaymentReturnable(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            setShowPaymentReturnModal(false);
            setShowPOSModalCancel(false);
            console.log(err);
        })
    }

    const handleCancelActiveVisit = () => {
        setLoadingCancelActiveVisit(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/cancel-active-visit`, {
            company: company.id,
        }).then((res) => {
            setShowCancelVisitModal(false);
            setLoadingCancelActiveVisit(false);
            if (res.data.status === "200") {
                dispatch(removeTab("visit-active"));
                dispatch(resetActiveVisit());
                dispatch(resetNewVisit());
                toast.success("Επιτυχής ακύρωση επίσκεψης.");
                dispatch(openNewVisit(TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingCancelActiveVisit(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <div className="data-panel-wr">
            {(templateEnable && hasSavePermission()) && (
                <div className={`${slideBarToggle  ? "template-header-ui-slide" : "template-header-ui"} template-select border-bottom pb-1 mb-3`}
                     style={{...slideBarToggle ? {} : {padding: "5px 20px 5px 74px !important"}}}>
                    <Row>
                        <Col xs="12" md="4">
                            <div className="inline-select-ui-4 template-dropdown">
                                <AdvancedCombobox
                                    className="w-100 ac-select-dropdown"
                                    defaultValue={defaultTemplate ? defaultTemplate?.label : ""}
                                    key={Math.random()}
                                    label={t('DataPanelIndex.template.template')}
                                    data={templateOptions(templateType)}
                                    onChange={(e) => handleTemplateChange(e)}
                                    excludeColumns={[]}
                                    columns={templateColumns}
                                    deleteEnable={true}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={t('DataPanelIndex.template.placeholder')}
                                    onDelete={handleDeleteTemplate}
                                />
                            </div>
                        </Col>
                        <Col
                            className="text-center justify-content-center align-items-center d-flex"
                            xs="12"
                            md="4"
                            xxl="6"
                        >
                            {<b className="heading">{t(headerNew)}</b>}
                        </Col>
                        <Col
                            xs="12"
                            md="4"
                            className=" justify-content-end align-items-center d-flex"
                        >
                            <SaveAsTemplate
                                templateData={templateFormData(templateType)}
                                requestData={requestData}
                                templateType={templateType}
                                templateList={templateOptions(templateType)}
                                saveCallback={() => {
                                    if (templateEnable) dispatch(fetchTemplates(requestData));
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            )}

            {(!templateEnable || !hasSavePermission()) && (
                <div className="template-header-ui dp-heading text-center border-bottom pb-4 mb-3 no-print" style={{...slideBarToggle ? {} : {padding: "5px 20px 5px 74px !important"}}}>
                    {<b className="heading">{t(headerNew)}</b>}
                </div>
            )}

            <ul className={`react-tabs__tab-list tab-style tab-min no-print`}>
                {tabs.map((tab, i) => {
                    if (checkPermission(tab.permission, permissionsData)) {
                        if (!(templateType === "advancedType" && SETTINGS.settings.newAdvancedType?.section === "Accounting Records" && tab.key === "advanced-types-new-accounting")
                        && !(templateType === "editAdvancedType" && SETTINGS.settings.editAdvancedType?.section === "Accounting Records" && tab.key === "advanced-types-edit-accounting")) {
                            return (
                                <li key={i} className="react-tabs__tab">
                                    <button
                                        onClick={() => {
                                            if (templateType) {
                                                setActiveLink(tab.tabNumber);
                                                dispatch(setRememberInnerTab({ [tabKey]: tab.tabNumber }));
                                            }
                                        }}
                                        className={`customNavBtn ${activeLink === tab.tabNumber && "btnActive"}`}
                                    >
                                        <span className="textWrapper">{t(tab.tabName)}</span>
                                    </button>
                                </li>
                            )
                        }
                    }
                    return <React.Fragment></React.Fragment>
                })}
            </ul>

            {/* BODY */}

            <div ref={(el) => {
                if (el) {
                    const tempKey = `${tabKey}-${activeLink}`;
                    containerRefs.current[tempKey] = el;
                }
            }} className="innerTabPanel data-panel-ui"
                  style={{
                      height: "100%",
                      paddingTop: "10px",
                  }}
                  >
                {activeLink === "Start" ? <Start/> : tabs.find((el) => el.tabNumber === activeLink)?.tabData}
            </div>
            {(PAYROLL.companyHasErgani && (templateType === "newEmployee" || templateType === "editEmployee")) && (
                <Row className={"justify-content-md-end"}>
                    {templateType === "editEmployee" && (
                        <React.Fragment>
                            {/*
                             {ACCOUNTING_DATA.editEmployee?.fromErgani === true && (
                                <Col md={3} className={"mt-2"}>
                                    <BetterCheckBox
                                        text={"Αποστολή μεταβολής σχέσεων εργασίας με βάση τις τροποποιήσεις (αν υπάρχουν) κατά την αποθήκευση"}
                                        checked={ACTIVITY.sendEmployeeChangesToErgani}
                                        onChange={(e) => {
                                            if (!ACTIVITY.saveEditEmployee) dispatch(setSaveEditEmployee(true));
                                            dispatch(setSendEmployeeChangesToErgani(e.target.checked));
                                        }}
                                    />
                                </Col>
                            )}
                            */}
                            <Col md={3} className={"mt-2"}>
                                <BetterCheckBox
                                    text={"Αποστολή νέου κωδικού κατά την αποθήκευση"}
                                    checked={ACTIVITY.sendEmployeeNewPasswordOnSave}
                                    onChange={(e) => {
                                        if (!ACTIVITY.saveEditEmployee) dispatch(setSaveEditEmployee(true));
                                        dispatch(setSendEmployeeNewPasswordOnSave(e.target.checked));
                                    }}
                                />
                            </Col>
                        </React.Fragment>
                    )}
                    <Col md={3} className={"mt-2"}>
                        <BetterCheckBox
                            text={templateType === "newEmployee" ? "Δημιουργία λογαριασμού & αποστολή QR κατά την αποθήκευση" : "Αποστολή QR κατά την αποθήκευση"}
                            checked={ACTIVITY.sendEmployeeQROnSave}
                            onChange={(e) => {
                                if (templateType === "newEmployee" && !ACTIVITY.saveNewEmployee) dispatch(setSaveNewEmployee(true));
                                if (templateType === "editEmployee" && !ACTIVITY.saveEditEmployee) dispatch(setSaveEditEmployee(true));
                                dispatch(setSendEmployeeQROnSave(e.target.checked));
                            }}
                        />
                    </Col>
                </Row>
            )}
            {(templateType === "editClient" && ["800566476", "800434990", "801866110"].includes(company.vatNumber) && hasSavePermission()) && (
                <Row className={"justify-content-md-end"}>
                    <Col md={3} className={"mt-2"}>
                        <BetterCheckBox
                            text={"Ενημέρωση πελάτη σε όλο το σύστημα"}
                            checked={ACTIVITY.saveEditClientInWholeSystem}
                            onChange={(e) => {
                                if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
                                dispatch(setSaveEditClientInWholeSystem(e.target.checked));
                            }}
                        />
                    </Col>
                </Row>
            )}
            {ACTIVITY?.sendEmail === "active" && sendEmailOnSave && (
                <div className="dp-footer d-flex justify-content-between">
                    <div className="d-flex justify-content-start">
                    </div>
                    <div className="d-flex justify-content-end">
                        <Row>
                            <Col>
                                <label htmlFor="contactPoints"
                                       className="mb-1 ml-3">{t('DataPanelIndex.sendEmailToExistingClientContactPoints')} </label>
                                <Dropdown
                                    multiSelect={true}
                                    position="top"
                                    options={recipientEmails}
                                    key={Math.random()}
                                    placeholder={t('DataPanelIndex.placeholder')}
                                    name={'contactPoints'}
                                    className="email-recipients"
                                    defaultValue={selectedRecipientEmails?.map((el) => {
                                        return {
                                            value: el,
                                            label: el,
                                        }
                                    })}
                                    onChange={(e) => handleOnEmailChange(e, 'msdd', 'gf')}
                                />
                                {(selectedRecipientEmails.length === 0 && selectedCustomRecipientEmails.length === 0) &&
                                    <div
                                        className="text-danger align-items-center d-flex justify-content-center">{t('DataPanelIndex.pleaseSelectAtLeastOneEmailAddress')}</div>}
                            </Col>
                            <Col>
                                <Input
                                    name="customEmails"
                                    placeholder={t('DataPanelIndex.sendEmailToCustomEmailAddresses.placeholder')}
                                    type="text"
                                    label={t('DataPanelIndex.sendEmailToCustomEmailAddresses.sendEmailToCustomEmailAddresses')}
                                    className="mb-3 custom-email-recipients"
                                    // value={selectedCustomRecipientEmails}
                                    onChange={(e) => handleOnEmailChange(e, 'dd', 'customEmails')}
                                />
                                {emailError === true && <div
                                    className="text-danger">{t('DataPanelIndex.sendEmailToCustomEmailAddresses.warning')}</div>}
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
            <div className="dp-footer justify-content-between">
                <div className="d-flex justify-content-start">
                    {printLayoutDropdown && (
                        <Dropdown
                            classes="inline-dropdown print-layout"
                            label={t('DataPanelIndex.printLayout')}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(printLayoutOptions, SALES.printLayout, "value", "label", "value")}
                            name="printLayout"
                            options={printLayoutOptions}
                            position="top"
                            onChange={(e) => handePrintLayoutChange(e)}
                        />
                    )}
                    {printBtn && (<Button
                            name="clear"
                            onClick={() => handleDpActions("print")}
                            className="ml-2 mb-3"
                            disabled={!showPrintBtn}
                        >
                            {t('DataPanelIndex.print')}
                        </Button>
                    )}
                </div>
                <div className="d-flex justify-content-end">
                    {sendEmailOnSave && (
                        <Row>
                            <Col className="mt-3">
                                <Checkbox
                                    className="w-100 sendEmailOnSave"
                                    text={t('DataPanelIndex.sendEmailOnSave')}
                                    name="sendEmailOnSave"
                                    key={Math.random()}
                                    defaultValue={ACTIVITY?.sendEmail}
                                    value={ACTIVITY?.sendEmail === "active" ? "inactive" : "active"}
                                    onChange={(e) => handleSendEmailOnSave(e)}
                                />
                            </Col>
                        </Row>
                    )}
                    {convertDocument && enableConvertDocumentButton && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("convertDocument")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.covertDocument')}
                        </Button>
                    )}
                    {convertQuotation && enableConvertQuotationButton && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("convertQuotation")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.convertQuotation')}
                        </Button>
                    )}
                    {issueCreditDocument && enableIssueCreditDocumentButton && (<Button
                            name="clear"
                            onClick={() => handleDpActions("issueCreditDocument")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.issueCreditDocument')}
                        </Button>
                    )}
                    {(cancelMyDataInvoice && templateType === "editSales" && SALES.editSales[tabKey].myDataStatus === "sent"
                        && (String(SALES.editSales[tabKey].myDataDestination).toLowerCase() !== "provider"
                        || (String(SALES.editSales[tabKey].myDataDestination).toLowerCase() === "provider" && ["9.1", "9.2", "9.3"].includes(SALES.editSales[tabKey].myDataType)))) && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("cancelMyDataInvoice")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.cancelInvoiceFromMyData')}
                        </Button>
                    )}
                    {(cancelMyDataInvoice && templateType === "editBuys" && BUYS.editBuys.myDataStatus === "sent" &&
                        (String(BUYS.editBuys.myDataDestination).toLowerCase() !== "provider" && BUYS.editBuys?.fromMyDataReport !== "true" && !BUYS.editBuys?.fromAI)
                        ||
                        (String(BUYS.editBuys.myDataDestination).toLowerCase() === "provider" && ["10.1", "10.2"].includes(BUYS.editBuys.myDataType))
                    ) && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("cancelMyDataInvoice")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.cancelInvoiceFromMyData')}
                        </Button>
                    )}
                    {(cancelMyDataInvoice && templateType === "editAccountingRecord" && ACCOUNTING_DATA.editAccountingRecord.myDataStatus === "sent") && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("cancelMyDataInvoice")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.cancelInvoiceFromMyData')}
                        </Button>
                    )}
                    {(cancelMyDataInvoice && templateType === "editFixedAssetRecord" && FIXED_ASSETS.editFixedAssetRecord.myDataStatus === "sent") && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("cancelMyDataInvoice")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.cancelInvoiceFromMyData')}
                        </Button>
                    )}
                    {clearBtn && (
                        <Button
                            name="clear"
                            onClick={() => handleDpActions("clear")}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.clear')}
                        </Button>
                    )}
                    {(templateType === "activeVisit") && (
                        <Button className="ml-2 mb-3" onClick={() => setShowCancelVisitModal(true)}>Ακύρωση</Button>
                    )}
                    {(saveandrepeat && hasSavePermission()) && (
                        <Button
                            name="saveandrepeat"
                            onClick={() => handleDpActions("saveandrepeat")}
                            disabled={actionsDisabled || loadingSaveAndRepeat || loadingSave || loadingSaveActiveVisitInvoice}
                            className="ml-2 mb-3"
                        >
                            {loadingSaveAndRepeat && (<span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>)}
                            {templateType === "activeVisit" ? "Ολοκλήρωση και νέα επίσκεψη" : t('DataPanelIndex.saveAndRepeat')}
                        </Button>
                    )}
                    {(deleteBtn && hasDeletePermission()) && (
                        <Button
                            name="delete"
                            onClick={() => handleDelete()}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.delete')}
                        </Button>
                    )}
                    {(templateType === "editSales" && SALES.editSales[tabKey]?.myDataDestination !== "provider" && SALES.editSales[tabKey]?.myDataStatus === "not_sent" && hasDeletePermission()) && (
                        <Button
                            name="delete"
                            onClick={() => handleDelete()}
                            disabled={loadingSave}
                            className="ml-2 mb-3"
                        >
                            {t('DataPanelIndex.delete')}
                        </Button>
                    )}
                    {(templateType === "editClientPayments" && paymentReturnable) && (
                        <Button className="ml-2 mb-3" onClick={() => setShowPaymentReturnModal(true)}>Έκδοση επιστροφής</Button>
                    )}
                    {(saveBtn && hasSavePermission()) && (
                        <React.Fragment>
                            <Button
                                name="save"
                                onClick={() => handleDpActions("save")}
                                disabled={actionsDisabled || loadingSave || loadingSaveAndRepeat || loadingSaveActiveVisitInvoice}
                                type="submit"
                                className="ml-2 mb-3"
                            >
                                {loadingSave && (<span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>)}
                                {templateType === "newVisit" ? "Καταχώρηση" : templateType === "activeVisit" ? "Ολοκλήρωση και προβολή" : t('DataPanelIndex.save')}
                            </Button>

                            {(templateType === "activeVisit" && (
                                    (PRESCRIPTION?.activeVisitReferrals?.length > 0 && String(PRESCRIPTION?.activeVisit?.inQuota) === "true")
                                    ||
                                    (String(PRESCRIPTION?.activeVisit?.inQuota) !== "true")
                                )
                            ) && (
                                <Button
                                    name="saveandrepeat2"
                                    onClick={() => {
                                        if (PRESCRIPTION?.activeVisitReferrals?.length > 0) {
                                            setShowVisitExecutedRefferals(true);
                                        } else {
                                            setLoadingSaveActiveVisitInvoice(true);
                                            handleDpActions("saveandrepeat", "activeVisitNewSale")
                                        }
                                    }}
                                    disabled={actionsDisabled || loadingSaveAndRepeat || loadingSave || loadingSaveActiveVisitInvoice}
                                    className="ml-2 mb-3"
                                >
                                    {loadingSaveActiveVisitInvoice && (<span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>)}
                                    <span>Ολοκλήρωση και έκδοση παραστατικού</span>
                                </Button>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
            <div ref={scrollToEnd}></div>

            {/* Confirm Template Change */}
            <Modal backdrop={"static"} className="themeModal" show={showTemplateConfirmation}>
                <Modal.Header>
                    <Modal.Title>{t('DataPanelIndex.templateChange')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('DataPanelIndex.templateWarning')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-primary"
                        onClick={() => setShowTemplateConfirmation(false)}
                    >
                        {t('DataPanelIndex.no')}
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmTemplate()}>
                        {t('DataPanelIndex.yes')}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Price List Confirmation */}
            <Modal backdrop={"static"} className="themeModal" show={activePriceListModal}>
                <Modal.Header>
                    <Modal.Title>{t('DataPanelIndex.activateConfirmation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {t('DataPanelIndex.activateMessage')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-primary"
                        onClick={() => setActivePriceListModal(false)}
                    >
                        {t('DataPanelIndex.cancel')}
                    </Button>
                    <Button variant="primary" onClick={() => handleSaveActivePriceList()}>
                        {t('DataPanelIndex.yes')}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Convert Document Confirmation */}
            <Modal backdrop={"static"} className="themeModal" show={showConvertDocumentConfirmation}>
                <Modal.Header>
                    <Modal.Title>{t('DataPanelIndex.convertDocumentConfirmation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {t('DataPanelIndex.convertDocumentMessage')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={disableConvertOkBtn}
                        variant="primary"
                        onClick={() => handleConvertDocumentConfirm(SALES.editSales[tabKey])}
                    >
                        {t('DataPanelIndex.yes')}
                    </Button>
                    <Button
                        variant="outline-primary"
                        onClick={() => setShowConvertDocumentConfirmation(false)}
                    >
                        {t('DataPanelIndex.no')}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Convert Quotation Confirmation */}
            <Modal backdrop={"static"} className={"themeModal"} show={showConvertQuotationConfirmation} onHide={() => setShowConvertQuotationConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('DataPanelIndex.convertQuotationConfirmation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-1 mt-2">
                        <Col sm={12} md={12} className="showWithOverlay">
                            <Dropdown
                                label={"Μετατροπή σε"}
                                key={convertQuotationToType ? convertQuotationToType : 'empty-selection'}
                                classes="w-100"
                                name="documentType"
                                required={true}
                                searchEnable={true}
                                options={documentTypesOptions}
                                defaultValue={getDefaultOptionByValue(documentTypesOptions, convertQuotationToType, 'value', 'label', 'value')}
                                onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={disableConvertOkBtn || !convertQuotationToType}
                        variant="primary"
                        onClick={() => handleConvertQuotationConfirm(SALES.editQuotations[tabKey])}
                    >
                        {t('DataPanelIndex.convert')}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Issue Credit Document */}
            <Modal backdrop={"static"} className="themeModal" show={showIssueCreditDocumentConfirmation}>
                <Modal.Header>
                    <Modal.Title>{t('DataPanelIndex.issueCreditDocumentConfirmation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {t('DataPanelIndex.issueCreditDocumentMessage')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={disableIssueCreditOkBtn}
                        variant="primary"
                        onClick={() => handleIssueCreditDocumentConfirm(SALES.editSales[tabKey]?._id, setDisableIssueCreditOkBtn)}
                    >
                        {t('DataPanelIndex.yes')} {disableIssueCreditOkBtn && <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                    </Button>
                    <Button
                        variant="outline-primary"
                        disabled={disableIssueCreditOkBtn}
                        onClick={() => setShowIssueCreditDocumentConfirmation(false)}
                    >
                        {t('DataPanelIndex.no')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} className="themeModal" show={showCancelDocumentConfirmation}>
                <Modal.Header>
                    <Modal.Title>{t('DataPanelIndex.cancelMyDataDocumentConfirmation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {t('DataPanelIndex.cancelMyDataDocumentMessage')}
                </Modal.Body>
                <Modal.Footer>
                    {templateType === "editSales" && (
                        <Button
                            disabled={disableCancelDocumentOkBtn}
                            variant="primary"
                            onClick={() => dispatch(cancelMyDataSale({
                                saleId: SALES.editSales[tabKey]?._id, company: company.id, year: company.year
                            }, setShowCancelDocumentConfirmation, setDisableCancelDocumentOkBtn))}
                        >
                            {t('DataPanelIndex.yes')} {disableCancelDocumentOkBtn && <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                        </Button>
                    )}
                    {templateType === "editBuys" && (
                        <Button
                            disabled={disableCancelDocumentOkBtn}
                            variant="primary"
                            onClick={() => dispatch(cancelMyDataBuy({
                                buyId: BUYS.editBuys?._id, company: company.id, year: company.year
                            }, setShowCancelDocumentConfirmation, setDisableCancelDocumentOkBtn))}
                        >
                            {t('DataPanelIndex.yes')} {disableCancelDocumentOkBtn && <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                        </Button>
                    )}
                    {templateType === "editAccountingRecord" && (
                        <Button
                            disabled={disableCancelDocumentOkBtn}
                            variant="primary"
                            onClick={() => dispatch(cancelMyDataAccountingRecord({
                                recordId: ACCOUNTING_DATA.editAccountingRecord?._id, company: company.id, year: company.year
                            }, setShowCancelDocumentConfirmation, setDisableCancelDocumentOkBtn))}
                        >
                            {t('DataPanelIndex.yes')} {disableCancelDocumentOkBtn && <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                        </Button>
                    )}
                    {templateType === "editFixedAssetRecord" && (
                        <Button
                            disabled={disableCancelDocumentOkBtn}
                            variant="primary"
                            onClick={() => dispatch(cancelMyDataFixedAssetRecord({
                                assetRecordId: FIXED_ASSETS.editFixedAssetRecord?._id, company: company.id, year: company.year
                            }, setShowCancelDocumentConfirmation, setDisableCancelDocumentOkBtn))}
                        >
                            {t('DataPanelIndex.yes')} {disableCancelDocumentOkBtn && <Spinner className={"ml-2"} animation="border" variant="dark"/>}
                        </Button>
                    )}
                    <Button
                        variant="outline-primary"
                        disabled={disableCancelDocumentOkBtn}
                        onClick={() => setShowCancelDocumentConfirmation(false)}
                    >
                        {t('DataPanelIndex.no')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showPOSModal}>
                <Modal.Header>
                    <Modal.Title>Πληρωμή με POS</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showPOSModalText}
                    <img src={"assets/images/POS.gif"} style={{display: "block", marginLeft: "auto", marginRight: "auto", width: "80%"}} alt={"Please check the POS"} />
                </Modal.Body>
            </Modal>

            <Modal show={showPOSModalCancel}>
                <Modal.Header>
                    <Modal.Title>Ακύρωση Πληρωμής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src={"assets/images/POSReturn.gif"} style={{display: "block", marginLeft: "auto", marginRight: "auto", width: "80%"}} alt={"Please check the POS"} />
                </Modal.Body>
            </Modal>

            <Modal backdrop={"static"} show={showPaymentReturnModal} onHide={() => setShowPaymentReturnModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Έκδοση Επιστροφής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να εκδώσετε επιστροφή σε αυτήν την είσπραξη;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowPaymentReturnModal(false)}>Όχι, ακύρωση</Button>
                    <Button onClick={() => handlePaymentReturn()}>Ναι, έκδοση</Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={emronAdminCancellationModal} onHide={() => setEmronAdminCancellationModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Απαιτείται προσοχή!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Οι τροποποιήσεις που γίνανε στον πελάτη απαιτούν ακύρωση συνδρομής. Είσαστε σίγουροι ότι θέλετε να προχωρήσετε;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setEmronAdminCancellationModal(false)}>Όχι</Button>
                    <Button onClick={() => handleDpActions("save", "editClient")}>Ναι, ακύρωση συνδρομής</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showCancelVisitModal} onHide={() => setShowCancelVisitModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Ακύρωση επίσκεψης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να ακυρώσετε την παρούσα ενεργή επίσκεψη;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowCancelVisitModal(false)}>Όχι</Button>
                    <Button onClick={() => handleCancelActiveVisit()} disabled={loadingCancelActiveVisit}>Ναι, ακύρωση {loadingCancelActiveVisit && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}</Button>
                </Modal.Footer>
            </Modal>

            <VisitExecutedReferrals
                show={showVisitExecutedReferrals}
                setShow={setShowVisitExecutedRefferals}
                referralData={PRESCRIPTION.activeVisitReferrals}
                callback={(selectedBarcodes) => handleDpActions("saveandrepeat", "activeVisitNewSale", selectedBarcodes)}
            />

            {/* Print Layout Templates */}
            {(SALES.printLayout === 'sales-print-template1-greek' || !SALES.printLayout) && (templateType === "sales" || templateType === "editSales" || templateType === "quotations" || templateType === "editQuotations") &&
                <SalesPrintTemplateGreek1 showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {SALES.printLayout === 'sales-print-template1-english' && (templateType === "sales" || templateType === "editSales" || templateType === "quotations" || templateType === "editQuotations") &&
                <SalesPrintTemplateEnglish1 showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {SALES.printLayout === 'sales-print-a5-greek' && (templateType === "sales" || templateType === "editSales" || templateType === "quotations" || templateType === "editQuotations") &&
                <SalesPrintA5Greek showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {SALES.printLayout === 'sales-print-a5-english' && (templateType === "sales" || templateType === "editSales" || templateType === "quotations" || templateType === "editQuotations") &&
                <SalesPrintA5English showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {SALES.printLayout === 'sales-print-a5-double-greek' && (templateType === "sales" || templateType === "editSales" || templateType === "quotations" || templateType === "editQuotations") &&
                <SalesPrintA5DoubleGreek showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {SALES.printLayout === 'sales-print-a5-double-english' && (templateType === "sales" || templateType === "editSales" || templateType === "quotations" || templateType === "editQuotations") &&
                <SalesPrintA5DoubleEnglish showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'clientpayments-print-template1-greek' || !SALES.printLayout) && (templateType === "clientPayments" || templateType === "editClientPayments") &&
                <ClientPaymentPrintTemplate1Greek showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'clientpayments-print-template1-english') && (templateType === "clientPayments" || templateType === "editClientPayments") &&
                <ClientpaymentPrintTemplate1English showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'thermal-print-55mm') && (templateType === "sales" || templateType === "editSales") &&
                <ThermalPrint55 showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'thermal-print-80mm') && (templateType === "sales" || templateType === "editSales") &&
                <ThermalPrint80 showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'thermal-print-110mm') && (templateType === "sales" || templateType === "editSales") &&
                <ThermalPrint110 showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'buy-print-a4-greek' || !SALES.printLayout) && (templateType === "buys" || templateType === "editBuys") &&
                <BuyPrintA4Greek showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            {(SALES.printLayout === 'buy-print-a4-english') && (templateType === "buys" || templateType === "editBuys") &&
                <BuyPrintA4English showWaterMark={false} ref={componentRef} data={printTemplateData}/>}
            <DeleteModal
                showDelete={showDeleteModal}
                showDeleteModal={showDeletionModal}
                toBeDeleted={toBeDeleted}
                tableName={deleteModalTableName}
                updateFunction={handleAfterDelete}
            />
            <RefreshEditModal />
        </div>
    )
}

export default DataPanel;
